import common from './common'
import featuresPay from './feature'

const km = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "ផលិតផល/វ៉ារ្យ៉ង់",
        serialNumber: "លេខស៊េរី",
        noProductsFound: "រកមិនឃើញផលិតផលទេ",
        searchByProductSku: "ស្វែងរកតាមផលិតផល/SKU",
        searchSerialNumbers: "ស្វែងរកលេខស៊េរី",
        transactionDetails: "ព័ត៌មានលម្អិតប្រតិបត្តិការ",
        notAvailable: "មិនមាន",
        mainWarehouse: "ឃ្លាំងធំ"
    },
    new_build_banner: {
        title: 'កំណែថ្មី:',
        is_available: 'មានសម្រាប់ប្រើប្រាស់ហើយ',
        fallback_title: 'មានកំណែថ្មីនៃកម្មវិធី',
        desc: 'បញ្ចូលឡើងវិញដើម្បីទទួលបានមុខងារ និងការកែលម្អចុងក្រោយបំផុត។',
        refreshing: 'កំពុងបញ្ចូលឡើងវិញ…',
        refresh_now: 'បញ្ចូលឡើងវិញឥឡូវនេះ',
        later: 'ពេលក្រោយ',
        you_are_on: "អ្នកកំពុងប្រើ"
    },
    short: {
        finance: 'ហិរញ្ញវត្ថុ',
        stock: 'ស្តុក'
    },
    onboarding: {
        welcome: 'សូមស្វាគមន៍!',
        step: {
            product: {
                totalBreakdown: 'ការបែងចែកសរុប',
                overallFulfilment: 'ការបំពេញការបញ្ជាទិញសរុប',
                totalShippedQty: 'បរិមាណដឹកជញ្ជូនសរុប',
                totalReceivedQty: 'បរិមាណទទួលបានសរុប',
                totalOrderedQty: 'បរិមាណបញ្ជាទិញសរុប',
                totalShippedOrdered: 'បានដឹកជញ្ជូនសរុប / បានបញ្ជាទិញ',
                totalReceivedOrdered: 'បានទទួលសរុប / បានបញ្ជាទិញ',
                viewQty: 'មើលបរិមាណ',
                fetchingQty: 'កំពុងទាញយកព័ត៌មានលម្អិតអំពីបរិមាណ...',
                noStockInfo: 'រកមិនឃើញព័ត៌មានស្តុកទេ',
                title: 'បានសម្រេច 65%',
                description: 'នៅសល់ត្រឹមតែ 2 ជំហានទៀតដើម្បីចាប់ផ្តើមជោគជ័យដ៏អស្ចារ្យរបស់អ្នក!',
                Warehouse: "ឃ្លាំង",
            },
            stock: {
                title: '95% ស្ទើរតែរួចរាល់!!',
                description: 'នៅសល់ត្រឹមតែ 1 ជំហានទៀតដើម្បីចាប់ផ្តើមជោគជ័យរបស់អ្នក! បញ្ចប់វាឥឡូវនេះ។'
            }
        },
        business: {
            title: 'បានបង្កើតអាជីវកម្មដោយជោគជ័យ!',
            description: 'ល្អណាស់! អាជីវកម្មរបស់អ្នកត្រូវបានចុះបញ្ជីហើយ'
        },
        product: {
            title: 'បន្ថែមផលិតផលដំបូងរបស់អ្នក',
            description: 'បន្ថែមផលិតផលដើម្បីចាប់ផ្តើមកំណត់ត្រាស្តុក',
            Warehouse: "ឃ្លាំង",
        },
        stock: {
            title: 'សាកល្បងបន្ថែមស្តុក',
            description: 'ចាប់ផ្តើមកំណត់ត្រាស្តុកចូល និងចេញ'
        },
        action: {
            add_business: {
                title: 'បង្កើតអាជីវកម្ម',
                description: 'ចង់បង្កើតអាជីវកម្មថ្មីមែនទេ? ចុចទីនេះ'
            },
            join_business: {
                title: 'ចូលរួមអាជីវកម្ម',
                description: 'មានលេខកូដអញ្ជើញ? ចូលរួមទីនេះ'
            }
        }
    },
    business: {
        title: 'ជ្រើសរើសអាជីវកម្ម បង្កើតថ្មី ឬចូលរួម',
        add_business: {
            title: 'បង្កើតអាជីវកម្មថ្មី',
            name: 'ឈ្មោះអាជីវកម្ម',
            name_placeholder: 'បញ្ចូលឈ្មោះ',
            category: 'ប្រភេទអាជីវកម្ម',
            category_placeholder: 'ជ្រើសរើសប្រភេទ',
            button: 'បង្កើតអាជីវកម្ម'
        },
        edit_business: {
            title: 'កែសម្រួលអាជីវកម្ម'
        },
        join_business: {
            title: 'ចូលរួមអាជីវកម្ម',
            input_code: 'បញ្ចូលលេខកូដអញ្ជើញខាងក្រោម៖',
            field_placeholder: 'លេខកូដអញ្ជើញ',
            confirm_title: 'ចូលរួម',
            confirm_text: 'អ្នកនឹងក្លាយជាសមាជិកក្នុងក្រុមនៅ '
        },
        no_business: 'មិនមានអាជីវកម្ម',
        create_or_join: 'បង្កើត ឬចូលរួមអាជីវកម្ម',
        message: {
            saved: 'បានរក្សាទុកអាជីវកម្មដោយជោគជ័យ!'
        },
        settings: {
            isNegativeTransactionDisabled: 'ប្រតិបត្តិការស្តុកអវិជ្ជមាន',
            isNegativeTransactionDisabledHint: 'តាមរយៈការបើកមុខងារនេះ អ្នកអាចការពារប្រតិបត្តិការដែលនឹងបណ្តាលឱ្យមានស្តុកអវិជ្ជមាន។',
            negativeStockError: 'ប្រតិបត្តិការស្តុកអវិជ្ជមានត្រូវបានបិទ'
        }
    },
    profile: {
        edit_profile: {
            title: 'កែសម្រួលប្រវត្តិ',
            name: 'ឈ្មោះពេញ',
            name_placeholder: 'បញ្ចូលឈ្មោះពេញ',
            email: 'អ៊ីមែល',
            phone_number: 'លេខទូរស័ព្ទ'
        },
        message: {
            required_name: 'ត្រូវការបញ្ចូលឈ្មោះ'
        }
    },
    product: {
        weightedAverageCost: 'ថ្លៃដើមមធ្យមទម្ងន់',
        weightedAverageValueLabel: 'តម្លៃមធ្យមទម្ងន់',
        Product: 'ផលិតផល',
        hideZeroStock: 'លាក់ស្តុកសូន្យ',
        allVariants: 'វ៉ារីយ៉ង់ទាំងអស់',
        choose_product: 'ជ្រើសរើសផលិតផល',
        choose_product_empty: 'ជ្រើសរើសផលិតផល និងបញ្ចូលបរិមាណ',
        choose_product_empty_manufacturing: 'ជ្រើសរើសផលិតផល និងបញ្ចូលបរិមាណផលិតកម្ម',
        search: {
            placeholder: 'ស្វែងរកតាមឈ្មោះ',
            tooltip: 'បើកម៉ាស៊ីនស្កេន',
            Warehouse: "ឃ្លាំង",
        },
        column: {
            image: 'រូបថត',
            name: 'ឈ្មោះ',
            price: 'តម្លៃ',
            buying_price: 'តម្លៃទិញ',
            selling_price: 'តម្លៃលក់',
            sku: 'លេខកូដ SKU',
            stock: 'ស្តុក',
            quantity: 'បរិមាណ',
            latest_stock: 'នៅសល់',
            product_deleted: 'ផលិតផលត្រូវបានលុប',
            info_not_found: 'មិនមានព័ត៌មាន',
            expired_date: 'កាលបរិច្ឆេទផុតកំណត់',
            invoice: 'វិក្កយបត្រ'
        },
        no_product: 'មិនមានផលិតផលទេ',
        no_product_subtitle: 'បន្ថែមផលិតផលដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើមតាមដានស្តុក តម្លៃ និងការលក់។',
        create_first_product: 'បង្កើតផលិតផលដំបូងរបស់អ្នក',
        add_product: {
            sku: 'លេខកូដផលិតផល',
            sku_placeholder: 'លេខកូដផលិតផល។ ឧទាហរណ៍: 12345',
            name: 'ឈ្មោះផលិតផល',
            name_placeholder: 'បញ្ចូលឈ្មោះផលិតផល',
            initial_stock: 'ស្តុកដំបូង',
            initial_stock_placeholder: 'បញ្ចូលស្តុកដំបូង',
            buying_price: 'តម្លៃទិញ',
            buying_price_placeholder: 'បញ្ចូលតម្លៃទិញ',
            selling_price: 'តម្លៃលក់',
            selling_price_placeholder: 'បញ្ចូលតម្លៃលក់',
            category: 'ប្រភេទ',
            category_placeholder: 'ជ្រើសរើសប្រភេទ',
            add_selling_price: 'បន្ថែមតម្លៃលក់ដុំ',
            expired_date: 'កាលបរិច្ឆេទផុតកំណត់',
            expired_date_placeholder: 'ជ្រើសកាលបរិច្ឆេទ',
            description: 'ការពិពណ៌នា',
            description_placeholder: 'បញ្ចូលការពិពណ៌នា',
            custom_label: 'លក្ខណៈសម្បត្តិ',
            custom_label_placeholder: 'បញ្ចូលកូនសោ',
            add_custom_label: 'បន្ថែមលក្ខណៈសម្បត្តិបន្ថែម',
            Warehouse: "ឃ្លាំង",
        },
        customerLabel: {},
        choose_selling_price: 'ជ្រើសរើសតម្លៃលក់',
        selling_price: 'តម្លៃលក់',
        total_product: 'ផលិតផលសរុប',
        total_quantity: 'ស្តុកសរុប',
        total_buying_price: 'តម្លៃទិញសរុប',
        total_selling_price: 'តម្លៃលក់សរុប',
        message: {
            required_name: 'ត្រូវការបញ្ចូលឈ្មោះផលិតផល',
            required_sku: 'ត្រូវការបញ្ចូលលេខកូដ SKU',
            required_category: 'ត្រូវការបញ្ចូលប្រភេទ',
            required_quantity: 'ត្រូវការបញ្ចូលស្តុកដំបូង',
            invalid_input_qty: 'បរិមាណស្តុកមិនត្រឹមត្រូវ',
            required_buying_price: 'ត្រូវការបញ្ចូលតម្លៃទិញ',
            required_selling_price: 'ត្រូវការបញ្ចូលតម្លៃលក់',
            required_selling_price_name: 'ត្រូវការបញ្ចូលឈ្មោះតម្លៃលក់',
            required_selling_price_price: 'ត្រូវការបញ្ចូលតម្លៃលក់'
        },
        viewMore: 'មើលបន្ថែម',
        WarehouseDetails: 'ព័ត៌មានឃ្លាំង',
        WarehouseName: 'ឈ្មោះឃ្លាំង',
        AddWarehouse: 'បន្ថែមឃ្លាំង',
        WarehouseQty: 'បរិមាណឃ្លាំង',
        Warehouse: 'ឃ្លាំង',
        Warehouses: 'ឃ្លាំង',
        Variants: 'វ៉ារ្យ៉ង់',
        VariantName: 'ឈ្មោះវ៉ារ្យ៉ង់',
        productVariant: 'វ៉ារ្យ៉ង់ផលិតផល',
        AddVariant: 'បន្ថែមវ៉ារ្យ៉ង់',
        TranferItem: 'ផ្ទេរទំនិញ',
        AddUnit: 'បន្ថែមឯកតា',
        InitialStkWarehouse: 'ត្រូវការស្តុកដំបូងដើម្បីបន្ថែមវ៉ារ្យ៉ង់',
        InitialStockinwarehouse: 'ស្តុកដំបូងនៅក្នុងឃ្លាំង',
        TotalQuantity: 'បរិមាណសរុប៖',
        AddNote: 'បន្ថែមចំណាំ (តម្លៃទិញ)',
        AddNotetitle: 'បន្ថែមចំណាំ',
        VariantSuccessMessage: 'បានធ្វើបច្ចុប្បន្នភាពវ៉ារ្យ៉ង់ផលិតផលដោយជោគជ័យ',
        Next: 'បន្ទាប់',
        Submit: 'ដាក់ស្នើ',
        INACTIVE: 'អសកម្ម',
        errorone: 'អូហ៍! បរិមាណដែលបានស្នើសុំសម្រាប់',
        errortwo: 'មិនត្រូវគ្នាជាមួយបរិមាណឃ្លាំងដែលបានកំណត់។ សូមកែសម្រួលបរិមាណ ឬបន្ថែមស្តុកវិញ។',
        SelectWarehouse: 'ជ្រើសរើសឃ្លាំង',
        SelectVariant: 'ជ្រើសរើសវ៉ារ្យ៉ង់',
        Discount: 'បញ្ចុះតម្លៃ',
        DiscountDetails: 'ព័ត៌មានបញ្ចុះតម្លៃ',
        FinalPrice: 'តម្លៃចុងក្រោយ',
        DiscountType: 'ប្រភេទបញ្ចុះតម្លៃ',
        DiscountPer: 'បញ្ចុះតម្លៃ %',
        DiscountValue: 'តម្លៃបញ្ចុះតម្លៃ',
        Discountonprice: 'បញ្ចុះតម្លៃលើតម្លៃ',
        Discountondiscount: 'បញ្ចុះតម្លៃលើបញ្ចុះតម្លៃ',
        AdditionalDiscount: 'បញ្ចុះតម្លៃបន្ថែម',
        SellingPrice: 'តម្លៃលក់៖',
        Save: 'រក្សាទុក',
        OnOriginalPrice: 'លើតម្លៃដើម',
        OnDiscountedPrice: 'លើតម្លៃបញ្ចុះតម្លៃ',
        columnSelector: {
            title: 'បង្ហាញជួរឈរ',
            columnsButton: 'ជួរឈរ',
            costPrice: 'តម្លៃដើម',
            sellingPrice: 'តម្លៃលក់',
            sku: 'SKU',
            warehouse: 'ឃ្លាំង',
            categories: 'ប្រភេទ',
            safetyStock: 'ស្តុកសុវត្ថិภาพ',
            attributes: 'គុណលក្ខណៈ',
            notes: 'កំណត់ចំណាំ',
            description: 'ការពិពណ៌នា',
            more: 'បន្ថែមទៀត',
            attribute: 'គុណលក្ខណៈ',
            attributesTitle: 'គុណលក្ខណៈ',
            categoriesTitle: 'ប្រភេទ',
            skuAliases: 'ឈ្មោះក្លែងក្លាយ SKU'
        }
    },
    note: {
        title: 'ចំណាំ',
        add: 'បន្ថែមចំណាំ',
        no_note: 'មិនមានចំណាំទេ'
    },
    settings: {
        category: 'ប្រភេទ',
        language: 'ភាសា',
        switch_business: 'ប្តូរអាជីវកម្ម',
        currencySelect: 'រូបិយប័ណ្ណ',
        languageChangeSuccess: 'បានធ្វើបច្ចុប្បន្នភាពរូបិយប័ណ្ណដោយជោគជ័យ',
        languageChangeErrorMessage: 'មានបញ្ហាក្នុងពេលធ្វើបច្ចុប្បន្នភាពរូបិយប័ណ្ណ',
        currencyAdded: "បានបន្ថែមរូបិយប័ណ្ណដោយជោគជ័យ",
        currencyDelete: "បានលុបរូបិយប័ណ្ណដោយជោគជ័យ"

    },
    selectProductStock: 'ជ្រើសរើសផលិតផល',
    category: {
        category_list: {
            title: 'ប្រភេទផលិតផល'
        },
        add_category: {
            button: 'ប្រភេទថ្មី',
            title: 'បន្ថែមប្រភេទថ្មី'
        },
        edit_category: {
            title: 'កែសម្រួលប្រភេទ'
        },
        name: 'ឈ្មោះប្រភេទ',
        name_placeholder: 'បញ្ចូលឈ្មោះប្រភេទ',
        no_category: 'មិនមានប្រភេទទេ'
    },
    staff: {
        add: 'បន្ថែមបុគ្គលិក',
        edit: 'កែប្រែបុគ្គលិក',
        access: {
            stock: 'ស្តុក',
            add_product: 'បន្ថែមផលិតផលថ្មី',
            edit_product: 'កែផលិតផល',
            delete_product: 'លុបផលិតផល',
            view_capital_price: 'មើលតម្លៃដើម',
            add_category: 'បន្ថែមប្រភេទថ្មី',
            edit_category: 'កែប្រភេទ',
            delete_category: 'លុបប្រភេទ',
            add_supplier: 'បន្ថែមអ្នកផ្គត់ផ្គង់ថ្មី',
            edit_supplier: 'កែអ្នកផ្គត់ផ្គង់',
            delete_supplier: 'លុបអ្នកផ្គត់ផ្គង់',
            add_customer: 'បន្ថែមអតិថិជនថ្មី',
            edit_customer: 'កែអតិថិជន',
            delete_customer: 'លុបអតិថិជន',
            add_staff: 'បន្ថែមបុគ្គលិក',
            edit_staff: 'កែបុគ្គលិក',
            delete_staff: 'លុបបុគ្គលិក',
            change_business_profile: 'ផ្លាស់ប្តូរទម្រង់អាជីវកម្ម',
            access_by_product_category: 'ការចូលប្រើតាមប្រភេទផលិតផល',
            no_category_message: 'អ្នកមិនមានប្រភេទផលិតផលណាមួយទេ។ សូមបន្ថែមប្រភេទផលិតផល។',
            expenses: 'ចំណាយ',
            view_expenses: 'មើលចំណាយ',
            add_expenses: 'បន្ថែមចំណាយ',
            edit_expenses: 'កែសម្រួលចំណាយ',
            delete_expenses: 'លុបចំណាយ',
            warehouse: 'ឃ្លាំង',
            add_new_warehouse: 'បន្ថែមឃ្លាំងថ្មី',
            edit_warehouse: 'កែសម្រួលឃ្លាំង',
            delete_warehouse: 'លុបឃ្លាំង',
            transfer_warehouse: 'ផ្ទេរឃ្លាំង',
            transfer_warehouse_approval: 'ការអនុម័តផ្ទេរឃ្លាំង',
            access_by_warehouse: 'ការចូលប្រើតាមឃ្លាំង',
            no_warehouse_message: 'អ្នកមិនបានបន្ថែមឃ្លាំងណាមួយទេ។ សូមបន្ថែមបញ្ជីឃ្លាំង។',
            purchase_order: "បញ្ជាទិញ",
            purchase_order_creation: "បង្កើតបញ្ជាទិញ",
            purchase_order_edit: "កែសម្រួលបញ្ជាទិញ",
            purchase_order_cancel: "បោះបង់បញ្ជាទិញ",
            purchase_order_reopen: "បើកបញ្ជាទិញឡើងវិញ",
            purchase_order_receive: "ទទួលបញ្ជាទិញ",
            sales_order: "បញ្ជាលក់",
            sales_order_creation: "បង្កើតបញ្ជាលក់",
            sales_order_edit: "កែសម្រួលបញ្ជាលក់",
            sales_order_cancel: "បោះបង់បញ្ជាលក់",
            sales_order_reopen: "បើកបញ្ជាលក់ឡើងវិញ",
            sales_order_receive: "បញ្ជាលក់បានផ្ញើ",
            purchase_order_approval: "អនុម័តបញ្ជាទិញ",
            sales_order_approval: "អនុម័តបញ្ជាលក់",
            can_do_available_warehouse: "ឃ្លាំងដែលមាន",
            add_batch: "អនុម័តការបង្កើតបាច់"
            ,
            notification: 'Notification',
            staffNotification: 'Enable Notification',
            assignee: "អ្នកទទួលបន្ទុក",
        },
        no_staff: 'មិនមានបុគ្គលិកទេ។'
    },
    code: {
        title: 'បានបន្ថែមបុគ្គលិកថ្មី!',
        subtitle: 'ចែករំលែកកូដអញ្ជើញខាងក្រោមដើម្បីចូលរួម៖',
        valid: 'កូដមានសុពលភាពត្រឹមតែ 48 ម៉ោងប៉ុណ្ណោះ',
        share: 'ចែករំលែកតាម WhatsApp',
        copied: 'បានចម្លង!',
        invalid: 'កូដមិនត្រឹមត្រូវ!'
    },
    history: {
        no_history: 'មិនមានប្រវត្តិទេ។',
        detail: {
            remove: 'លុបប្រវត្តិ',
            confirm: 'មុខងារនេះនឹងប៉ះពាល់ដល់ស្តុក ប្រវត្តិ និងរបាយការណ៍ដែលមាន។'
        },
        no_history_selected: "មិនមានប្រវត្តិដែលបានជ្រើសរើស",
        select_history_hint: "ចុចលើប្រវត្តិពីបញ្ជីដើម្បីមើលព័ត៌មានលម្អិត",
        select_from_left: "ជ្រើសរើសពីផ្ទាំងខាងឆ្វេង",
    },
    supplier: {
        add: {
            title: 'បន្ថែមអ្នកផ្គត់ផ្គង់'
        },
        edit: {
            title: 'កែអ្នកផ្គត់ផ្គង់'
        },
        new: 'អ្នកផ្គត់ផ្គង់ថ្មី',
        no_supplier: 'មិនមានអ្នកផ្គត់ផ្គង់ទេ។',
        bank: {
            title: 'ព័ត៌មានធនាគារ'
        },
        note: 'កំណត់ចំណាំ',
        form: {
            name: {
                label: 'ឈ្មោះអ្នកផ្គត់ផ្គង់',
                placeholder: 'បញ្ចូលឈ្មោះអ្នកផ្គត់ផ្គង់',
                placheolder_not_mandatory: 'បញ្ចូលឈ្មោះ ',
                error: {
                    required: 'ឈ្មោះមិនអាចទទេបានទេ'
                }
            },
            contact: {
                label: 'លេខទំនាក់ទំនង',
                placeholder: '91934554432',
                error: {
                    required: 'លេខទំនាក់ទំនងមិនអាចទទេបានទេ',
                    invalid: 'លេខមិនត្រឹមត្រូវ។ ត្រូវតែបញ្ចូលកូដប្រទេស'
                }
            },
            bank_name: {
                label: 'ឈ្មោះធនាគារ',
                placeholder: 'បញ្ចូលឈ្មោះធនាគារ'
            },
            bank_account_name: {
                label: 'ឈ្មោះម្ចាស់គណនី',
                placeholder: 'បញ្ចូលឈ្មោះម្ចាស់គណនី'
            },
            bank_account_number: {
                label: 'លេខគណនី',
                placeholder: 'បញ្ចូលលេខគណនី'
            },
            note: {
                label: 'កំណត់ចំណាំ',
                placeholder: 'បញ្ចូលកំណត់ចំណាំ'
            },
            openingBalance: {
                addBtn: 'បន្ថែមសមតុល្យដើមគ្រា',
                label: 'សមតុល្យដើមគ្រា',
                placeholder: 'បញ្ចូលសមតុល្យដើមគ្រា',
                error: {
                    negative: 'សមតុល្យដើមគ្រាមិនអាចជាអវិជ្ជមានទេ'
                }
            }
        },
        choose: 'ជ្រើសរើសអ្នកផ្គត់ផ្គង់'
    },
    customer: {
        add: {
            title: 'បន្ថែមអតិថិជន'
        },
        edit: {
            title: 'កែអតិថិជន'
        },
        new: 'អតិថិជនថ្មី',
        no_customer: 'មិនមានអតិថិជនទេ។',
        note: 'កំណត់ចំណាំ',
        form: {
            name: {
                label: 'ឈ្មោះអតិថិជន',
                placeholder: 'បញ្ចូលឈ្មោះអតិថិជន',
                placheolder_not_mandatory: 'បញ្ចូលឈ្មោះ',
                error: {
                    required: 'ឈ្មោះមិនអាចទទេបានទេ'
                }
            },
            contact: {
                label: 'លេខទំនាក់ទំនង',
                placeholder: '91934554432',
                error: {
                    required: 'លេខទំនាក់ទំនងមិនអាចទទេបានទេ',
                    invalid: 'លេខមិនត្រឹមត្រូវ។ ត្រូវតែបញ្ចូលកូដប្រទេស'
                }
            },
            address: {
                label: 'អាសយដ្ឋាន',
                placeholder: 'បញ្ចូលអាសយដ្ឋាន'
            },
            note: {
                label: 'កំណត់ចំណាំ',
                placeholder: 'បញ្ចូលកំណត់ចំណាំ'
            },
            openingBalance: {
                addBtn: 'បន្ថែមសមតុល្យដើមគ្រា',
                label: 'សមតុល្យដើមគ្រា',
                placeholder: 'បញ្ចូលសមតុល្យដើមគ្រា',
                error: {
                    negative: 'សមតុល្យដើមគ្រាមិនអាចជាអវិជ្ជមានទេ'
                }
            }
        },
        choose: "ជ្រើសរើសអតិថិជន",
        report: {
            view: 'មើលរបាយការណ៍អ្នកទិញ',
            title: 'របាយការណ៍អតិថិជន',
            no_report: 'មិនមានរបាយការណ៍សម្រាប់អ្នកទិញនៅថ្ងៃដែលបានជ្រើសរើស។',
            column: {
                name: 'ឈ្មោះ',
                total_transaction: 'ចំនួនប្រតិបត្តិការសរុប',
                total_amount: 'ការលក់សរុប',
                total_profit: 'ប្រាក់ចំណេញសរុប'
            }
        }
    },
    confirm_delete: 'តើអ្នកពិតជាចង់លុបទិន្នន័យនេះមែនទេ?',
    report: {
        title: 'របាយការណ៍'
    },
    accounting: {
        download_pdf_report: 'ទាញយក PDF',
        title: 'គណនេយ្យ',
        view_report: 'មើលរបាយការណ៍ហិរញ្ញវត្ថុ',
        dashboard_title: 'របាយការណ៍ហិរញ្ញវត្ថុ',
        stats: 'ស្ថិតិ',
        accounting_report: 'របាយការណ៍គណនេយ្យ',
        filter: {
            date: {
                placeholder: 'ជ្រើសរើសកាលបរិច្ឆេទ',
                submit: 'អនុវត្ត',
                cancel: 'កំណត់តម្រងឡើងវិញ'
            },
            timeframe: {
                day: 'ប្រចាំថ្ងៃ',
                week: 'ប្រចាំសប្តាហ៍',
                month: 'ប្រចាំខែ',
                year: 'ប្រចាំឆ្នាំ'
            }
        },
        total_sales: 'ការលក់សរុប',
        total_purchases: 'ការទិញសរុប',
        total_profit: 'ប្រាក់ចំណេញសរុប',
        total_expenses: 'ចំណាយសរុប',
        assets_value: 'តម្លៃទ្រព្យសកម្មបច្ចុប្បន្ន',
        total_current_cogs_value: 'តម្លៃ COGS សរុបបច្ចុប្បន្ន',
        current_asset_selling_price: 'តម្លៃលក់ទ្រព្យសកម្មបច្ចុប្បន្ន',
        total_selling_price: 'តម្លៃលក់សរុប',
        table: {
            date: 'កាលបរិច្ឆេទ',
            sales: 'ការលក់',
            purchases: 'ការទិញ',
            profit: 'ប្រាក់ចំណេញ',
            expenses: 'ចំណាយ'
        },
        no_data: 'មិនមានទិន្នន័យទេ។'
    },
    stock_report: {
        title: 'របាយការណ៍ស្តុក',
        view: 'មើលរបាយការណ៍ស្តុក',
        no_report: 'មិនមានកំណត់ត្រាស្តុកសម្រាប់កាលបរិច្ឆេទ ឬបុគ្គលិកដែលបានជ្រើសរើសទេ។',
        allStaffPlaceHolder: 'បុគ្គលិកទាំងអស់',
        column: {
            total_product: 'ប្រភេទផលិតផលបច្ចុប្បន្ន',
            total_product_quantity: 'ចំនួនផលិតផលសរុបបច្ចុប្បន្ន'
        }
    },
    subscription: {
        paywall_small: {
            title: 'មុខងារ VIP',
            description:
                'រយៈពេលសាកល្បងសម្រាប់មុខងារនេះបានបញ្ចប់។ សូមគាំទ្រការអភិវឌ្ឍកម្មវិធីក្នុងតំបន់នេះដោយជាវ។',
            button: 'មើលផែនការជាវ'
        }
    },
    payment: {
        order: {
            title: 'ការទូទាត់'
        }
    },
    imageUploadMessage: {
        uploadSize: 'ទំហំរូបភាពមិនត្រូវលើស 5MB ទេ!',
        failedMessage: 'ការផ្ទុករូបភាពទំនិញបរាជ័យ សូមព្យាយាមម្តងទៀត!',
        successUpload: 'រូបភាពបានផ្ទុកដោយជោគជ័យ!',
        failedUIError: 'ការលុបរូបភាពបរាជ័យ សូមព្យាយាមម្តងទៀត!',
        SuccessErrorImage: 'រូបភាពត្រូវបានលុបដោយជោគជ័យ!'
    },
    productColumns: {
        SKULabel: 'កូដផលិតផល (SKU)',
        nameLabel: 'ឈ្មោះផលិតផល',
        categoryLabel: 'ប្រភេទ',
        BuyingPriceLabel: 'តម្លៃទិញ',
        SellingLabel: 'តម្លៃលក់',
        StockLabel: 'ស្តុក'
    },
    historyColumns: {
        Transactionlabel: 'ប្រភេទប្រតិបត្តិការ',
        Locallabel: 'ម៉ោងក្នុងតំបន់',
        Createdlabel: 'បង្កើតដោយ',
        Vendorlabel: 'ឈ្មោះអ្នកផ្គត់ផ្គង់',
        Buyerlabel: 'ឈ្មោះអ្នកទិញ',
        SKUlabel: 'កូដផលិតផល (SKU)',
        Invoicelabel: 'វិក្កយបត្រ',
        Productlabel: 'ឈ្មោះផលិតផល',
        Categorylabel: 'ប្រភេទ',
        Buyinglabel: 'តម្លៃទិញ',
        Sellinglabel: 'តម្លៃលក់',
        Initiallabel: 'ស្តុកដើម',
        Finallabel: 'ស្តុកចុងក្រោយ',
        Stocklabel: 'ការផ្លាស់ប្តូរស្តុក'
    },
    stockReportColumns: {
        skuLabel: 'កូដផលិតផល (SKU)',
        productNameLabel: 'ឈ្មោះផលិតផល',
        categoryLabel: 'ប្រភេទ',
        buyingPriceLabel: 'តម្លៃទិញ',
        sellingPriceLabel: 'តម្លៃលក់',
        stockInLabel: 'ស្តុកចូល',
        stockOutLabel: 'ស្តុកចេញ',
        remainingStockLabel: 'ស្តុកនៅសល់',
        openStockLabel: 'ស្តុកដើម',
        weightedAverageCost: 'ថ្លៃដើមមធ្យមទម្ងន់',
        weightedAverageCostLabel: 'ថ្លៃដើមមធ្យមទម្ងន់',
        weightedAverageValueLabel: 'តម្លៃមធ្យមទម្ងន់'
    },
    accountingReportColumns: {
        dateRange: 'ចន្លោះកាលបរិច្ឆេទ',
        reportingPeriod: 'រយៈពេលរបាយការណ៍',
        reportGenerate: 'បង្កើតរបាយការណ៍',
        warehouse: 'ឃ្លាំង',
        labelDate: 'កាលបរិច្ឆេទ',
        labelSales: 'ការលក់',
        labelPurchases: 'ការទិញ',
        labelProfit: 'ប្រាក់ចំណេញ',
        labelExpenses: 'ការចំណាយ',
        reportOptions: 'ជួរឈររបាយការណ៍',
        summaryCards: 'កាតសង្ខេប',
        grandTotal: 'សរុបរួម',
        continued: 'បន្ត',
        subtotal: 'សរុបរង',
        page: 'ទំព័រ'
    },
    customerReportColumns: {
        labelName: 'ឈ្មោះ',
        labelTotalTransaction: 'ប្រតិបត្តិការសរុប',
        labelTotalSales: 'ការលក់សរុប',
        labelTotalProfit: 'ប្រាក់ចំណេញសរុប'
    },
    scannerDialog: {
        finished: 'បានបញ្ចប់',
        reduce: 'បន្ថយ',
        successfull: 'ជោគជ័យ',
        searching: 'កំពុងស្វែងរក...',
        title: 'ម៉ាស៊ីនស្កែនសកម្ម។ សូមចង្អុលវាទៅកូដបារកូដ!'
    },
    historyFilter: {
        SelectBuyer: 'ជ្រើសរើសអ្នកទិញ',
        SelectVendor: 'ជ្រើសរើសអ្នកផ្គត់ផ្គង់'
    },
    productStockFilter: {
        StockLowtoHigh: 'ស្តុកពីតិចទៅច្រើន',
        StockHightoLow: 'ស្តុកពីច្រើនទៅតិច',
        AlphabetAZ: 'អក្សរ A-Z',
        AlphabetZA: 'អក្សរ Z-A'
    },
    minimizeTitle: 'ម៉ាស៊ីនស្កែនសកម្ម',
    security_guarantee: {
        title: 'ការធានាសុវត្ថិភាពទិន្នន័យ'
    },
    invoice: {
        invoicePlaceholder: 'លេខវិក្កយបត្រ',
        invoiceTitle: 'វិក្កយបត្រ',
        manageInvoiceAddress: 'គ្រប់គ្រងអាសយដ្ឋានវិក្កយបត្រ',
        selectOrManageAddresses: 'ជ្រើសរើស កែប្រែ ឬបង្កើតអាសយដ្ឋានវិក្កយបត្រផ្ទាល់ខ្លួន',
        useBusinessProfileAddress: 'ប្រើអាសយដ្ឋានប្រវត្តិរូបអាជីវកម្ម',
        noCustomAddressesFound: 'មិនមានអាសយដ្ឋានផ្ទាល់ខ្លួនបានបន្ថែម',
        createCustomAddressDesc: 'បន្ថែមអាសយដ្ឋានវិក្កយបត្រ ឬសាខាផ្ទាល់ខ្លួនដើម្បីបោះពុម្ពលើវិក្កយបត្ររបស់អ្នកជំនួសទិន្នន័យប្រវត្តិរូបអាជីវកម្មលំនាំដើម។',
        defaultFromBusinessProfile: 'លំនាំដើមពីប្រវត្តិរូបអាជីវកម្ម',
        editInvoiceAddress: 'កែប្រែអាសយដ្ឋានវិក្កយបត្រ',
        createNewInvoiceAddress: 'បង្កើតអាសយដ្ឋានវិក្កយបត្រថ្មី',
        logoHeaderImage: 'និមិត្តសញ្ញា / រូបភាពបឋមកថា',
        deleteInvoiceAddress: 'លុបអាសយដ្ឋានវិក្កយបត្រ?',
        deleteAddressConfirmText: 'តើអ្នកពិតជាចង់លុបអាសយដ្ឋានវិក្កយបត្រនេះ? សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។'
    },
    ManageInvoiceAddress: 'គ្រប់គ្រងអាសយដ្ឋានវិក្កយបត្រ',
    SelectOrManageAddresses: 'ជ្រើសរើស កែប្រែ ឬបង្កើតអាសយដ្ឋានវិក្កយបត្រផ្ទាល់ខ្លួន',
    UseBusinessProfileAddress: 'ប្រើអាសយដ្ឋានប្រវត្តិរូបអាជីវកម្ម',
    CreateNewAddress: 'បង្កើតអាសយដ្ឋានថ្មី',
    UpdatingList: 'កំពុងធ្វើបច្ចុប្បន្នភាពបញ្ជី...',
    NoCustomAddressesFound: 'មិនមានអាសយដ្ឋានផ្ទាល់ខ្លួនបានបន្ថែម',
    CreateCustomAddressDesc: 'បន្ថែមអាសយដ្ឋានវិក្កយបត្រ ឬសាខាផ្ទាល់ខ្លួនដើម្បីបោះពុម្ពលើវិក្កយបត្ររបស់អ្នកជំនួសទិន្នន័យប្រវត្តិរូបអាជីវកម្មលំនាំដើម។',
    DefaultFromBusinessProfile: 'លំនាំដើមពីប្រវត្តិរូបអាជីវកម្ម',
    EditInvoiceAddress: 'កែប្រែអាសយដ្ឋានវិក្កយបត្រ',
    CreateNewInvoiceAddress: 'បង្កើតអាសយដ្ឋានវិក្កយបត្រថ្មី',
    LogoHeaderImage: 'និមិត្តសញ្ញា / រូបភាពបឋមកថា',
    UploadingImage: 'កំពុងផ្ទុករូបភាព...',
    UploadImage: 'ផ្ទុករូបភាព',
    BusinessName: 'ឈ្មោះអាជីវកម្ម',
    AddressDetails: 'ព័ត៌មានលម្អិតអាសយដ្ឋាន',
    PhoneNumber: 'លេខទូរស័ព្ទ',
    EmailAddress: 'អាសយដ្ឋានអ៊ីមែល',
    DeleteInvoiceAddress: 'លុបអាសយដ្ឋានវិក្កយបត្រ?',
    DeleteAddressConfirmText: 'តើអ្នកពិតជាចង់លុបអាសយដ្ឋានវិក្កយបត្រនេះ? សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។',

    stocklowreport: {
        no_stocklowreport_one: 'មិនមានទំនិញដែលកំណត់ស្តុកសុវត្ថិភាពទេ។',
        no_stocklowreport_two: 'សូមបន្ថែមបរិមាណស្តុកសុវត្ថិភាព។',
        currentStock: 'ស្តុកបច្ចុប្បន្ន',
        safetyStock: 'ស្តុកសុវត្ថិភាព',
        pricing: 'តម្លៃ',
        costPrice: 'ថ្លៃដើម',
        sellingPrice: 'តម្លៃលក់',
        productInfo: 'ព័ត៌មានផលិតផល',
        category: 'ប្រភេទ',
        description: 'ការពិពណ៌នា',
        no_description: 'មិនទាន់បានបន្ថែមការពិពណ៌នាទេ',
        variants: 'ជម្រើស',
        unitsOnHand: 'ឯកតាដែលមានក្នុងស្តុក',
        minimumThreshold: 'កម្រិតអប្បបរមា',
        adjust: 'កែតម្រូវ',
        all: 'ទាំងអស់',
        lowStock: 'ស្តុកទាប',
        variantsDetails: 'ព័ត៌មានលម្អិតអំពីជម្រើស',
        qty: 'បរិមាណ',
        addSafetyStock: 'បន្ថែមស្តុកសុវត្ថិភាព',
        searchByNameSku: 'ស្វែងរកតាមឈ្មោះ/SKU',
        safetyStockShort: 'ស',
        warehouseSafetyStock: 'ស្តុកសុវត្ថិភាពក្នុងឃ្លាំង'
    },
    low_alert_stock: 'បញ្ចូលបរិមាណស្តុកសុវត្ថិភាព',
    lowStockAlertNotify: 'អ្នកនឹងទទួលបានការជូនដំណឹងនៅពេលស្តុកធ្លាក់ចុះក្រោមបរិមាណដែលបានកំណត់',
    applyButtonStockAlert: 'អនុវត្ត',
    cancelButtonStockAlert: 'បោះបង់',
    searchProductLabel: 'ស្វែងរកផលិតផល...',
    successfullyAddedSafetyStock: 'បានធ្វើបច្ចុប្បន្នភាពស្តុកសុវត្ថិភាពដោយជោគជ័យ',
    safety_Stock: 'ស្តុកសុវត្ថិភាព',
    safety_stock_placeholder: 'បញ្ចូលស្តុកសុវត្ថិភាព',
    lowStockDetailsInfo: {
        ProductCode: 'កូដផលិតផល',
        SafetyStock: 'ស្តុកសុវត្ថិភាព',
        Stock: 'ស្តុក',
        CostPrice: 'តម្លៃដើម',
        SellingPrice: 'តម្លៃលក់',
        Category: 'ប្រភេទ',
        Description: 'ការពិពណ៌នា',
        ExpirationDate: 'កាលបរិច្ឆេទផុតកំណត់'
    },
    CustomLang: {
        Attribute: 'លក្ខណៈសម្បត្តិ',
        AddAttribute: 'បន្ថែមលក្ខណៈសម្បត្តិ',
        EditAttribute: 'កែប្រែលក្ខណៈសម្បត្តិ',
        CustomLabePlaceholder: 'បញ្ចូលឈ្មោះលក្ខណៈសម្បត្តិ',
        CustomLabePlaceholderSelect: 'ជ្រើសរើសប្រភេទ',
        AddMoreAttribute: 'បន្ថែមលក្ខណៈសម្បត្តិផ្សេងទៀត',
        ItemAttribute: 'លក្ខណៈសម្បត្តិទំនិញ',
        TableName: 'ឈ្មោះ',
        TableType: 'ប្រភេទ',
        TableAction: 'សកម្មភាព',
        TableDelete: 'លុប',
        TableEdit: 'កែប្រែ',
        deleteMessage: 'លក្ខណៈសម្បត្តិត្រូវបានលុបដោយជោគជ័យ',
        editSuccessMessage: 'បានធ្វើបច្ចុប្បន្នភាពលក្ខណៈសម្បត្តិដោយជោគជ័យ',
        AddSuccessMessage: 'បានបន្ថែមលក្ខណៈសម្បត្តិដោយជោគជ័យ',
        AddAtt: 'បន្ថែម',
        EditAtt: 'កែប្រែ',
        SubmitAtt: 'កំពុងដាក់ស្នើ...'
    },
    Expenses: {
        ExpensesTitle: 'ចំណាយ',
        AddExpenses: 'បន្ថែមចំណាយ',
        ExpenseCategory: 'ប្រភេទចំណាយ',
        NoExpenseCategory: 'មិនមានប្រភេទចំណាយទេ',
        AddExpenseCategory: 'បន្ថែមប្រភេទចំណាយ',
        SelectExpenseCategory: 'ជ្រើសរើសប្រភេទចំណាយ',
        NoExpenses: 'មិនមានចំណាយទេ',
        ExpensesSuccess: 'បានបង្កើតចំណាយដោយជោគជ័យ',
        ExpensesSuccessEdit: 'បានធ្វើបច្ចុប្បន្នភាពចំណាយដោយជោគជ័យ',
        ExpensesCategoryName: 'ឈ្មោះប្រភេទចំណាយ',
        ExpensesSuccessDelete: 'បានលុបចំណាយដោយជោគជ័យ',
        AddNEC: "បន្ថែមប្រភេទចំណាយថ្មី",
        NC: "ប្រភេទចំណាយថ្មី",
        EditNEC: "កែសម្រួលប្រភេទចំណាយ"
    },
    Manufacturing: {
        ProducedProduct: "ផលិតផលដែលបានផលិត",
        QuantityManufactured: "បរិមាណដែលបានផលិត",
        UnitCost: "ថ្លៃដើមក្នុងមួយឯកតា",
        RawMaterialsTotal: "វត្ថុធាតុដើមសរុប",
        TotalManufacturingCost: "ថ្លៃដើមផលិតសរុប",
        NoRawMaterialsConsumed: "មិនមានការប្រើប្រាស់វត្ថុធាតុដើមទេ។",
        CostBreakdown: "ការវិភាគថ្លៃដើម",
        GeneratedBatch: "ឡូតិ៍ដែលបានបង្កើត",
        StoredBinLocation: "ទីតាំងផ្ទុក",
        NoManufacturingTransactionsFound: "រកមិនឃើញប្រតិបត្តិការផលិតទេ",
        AddManufacture: 'បន្ថែមព័ត៌មានផលិតកម្ម',
        Manufacturing: 'ផលិតកម្ម',
        RawMaterials: 'វត្ថុធាតុដើម',
        AdditonCosts: 'ចំណាយបន្ថែម',
        RawMaterial: 'វត្ថុធាតុដើម',
        AdditonCost: 'ចំណាយបន្ថែម',
        TotalCost: 'តម្លៃសរុប',
        AddRawMaterial: 'បន្ថែមវត្ថុធាតុដើមសម្រាប់',
        AddAdditonCost: 'បន្ថែមចំណាយបន្ថែមសម្រាប់',
        AddMore: 'បន្ថែមទៀត',
        Add: 'បន្ថែម',
        Update: 'ធ្វើបច្ចុប្បន្នភាព',
        Updating: 'កំពុងដាក់ស្នើ...',
        ProductRequired: 'ទាមទារផលិតផល',
        QuantityRequired: 'ទាមទារបរិមាណ',
        ChargeRequired: 'ទាមទារការចំណាយ',
        EstimatedCostRequired: 'ទាមទារតម្លៃប៉ាន់ស្មាន',
        PurchasePriceRequired: 'ទាមទារតម្លៃទិញ',
        SelectCharge: 'ជ្រើសរើសការចំណាយ',
        EstimatedCost: 'តម្លៃប៉ាន់ស្មាន',
        SelectProduct: 'ជ្រើសរើសផលិតផល',
        Quantity: 'បរិមាណ',
        ManufactureDetails: 'ព័ត៌មានផលិតកម្ម',
        BuyingPrice: 'តម្លៃទិញ',
        LabourCharge: 'ថ្លៃឈ្នួល',
        ElectricityCost: 'ថ្លៃអគ្គិសនី',
        PackagingCharge: 'ថ្លៃវេចខ្ចប់',
        LogisticCost: 'ថ្លៃដឹកជញ្ជូន',
        OtherCharges: 'ចំណាយផ្សេងៗ',
        Save: 'រក្សាទុកព័ត៌មាន',
        PurchasePrice: 'តម្លៃទិញ',
        Date: 'កាលបរិច្ឆេទ',
        For: 'សម្រាប់',
        PurchaseRate: 'តម្លៃទិញ (តម្លៃ)',
        Scrolltoloadmore: 'អូសដើម្បីផ្ទុកបន្ថែម...',
        Noproductsfound: 'រកមិនឃើញផលិតផល',
        ManufacturingQuantity: 'បរិមាណផលិតកម្ម',
        ManufactureAddedSuccess: 'បានធ្វើបច្ចុប្បន្នភាពព័ត៌មានផលិតកម្មដោយជោគជ័យ'
    },
    Warehouses: {
        transferOrder: 'ផ្ទេរទំនិញ',
        AddTransferOrder: 'បន្ថែមការផ្ទេរទំនិញ',
        NewWarehouse: 'ឃ្លាំងថ្មី',
        newHead: 'ចាប់ផ្តើមគ្រប់គ្រងឃ្លាំងច្រើន!',
        headTwo: 'តាមដាន និងគ្រប់គ្រងស្តុករបស់អ្នកក្នុងឃ្លាំងច្រើនបានយ៉ាងងាយស្រួល',
        EnableWarehouse: 'បើកឃ្លាំង',
        EnableWarehouse2: 'បើកឃ្លាំង',
        OrganizationPrimary: 'ឃ្លាំងសំខាន់របស់អង្គភាព',
        Edit: 'កែប្រែ',
        AreEnableWarehouse: 'តើអ្នកពិតជាចង់បើកឃ្លាំងមែនទេ?',
        Confirm: 'បញ្ជាក់',
        Cancel: 'បោះបង់',
        WarehouseCreatedSuccessfully: 'បានបង្កើតឃ្លាំងដោយជោគជ័យ',
        MarkAsOP: 'សម្គាល់ថាជាឃ្លាំងសំខាន់របស់អង្គភាព',
        MarkAsInAct: 'សម្គាល់ថាអសកម្ម',
        MarkAsAct: 'សម្គាល់ថាសកម្ម',
        MarkedAsInactive: 'ឃ្លាំងត្រូវបានសម្គាល់ថាអសកម្មដោយជោគជ័យ',
        MarkedAsActive: 'ឃ្លាំងត្រូវបានសម្គាល់ថាសកម្មដោយជោគជ័យ',
        MarkedAsOP: 'ឃ្លាំងត្រូវបានសម្គាល់ថាសកម្មដោយជោគជ័យ',
        WareDeletedSuccess: 'បានលុបឃ្លាំងដោយជោគជ័យ',
        SuccessfullyUpdatedWarehouse: 'បានធ្វើបច្ចុប្បន្នភាពឃ្លាំងដោយជោគជ័យ',
        SuccessfullyCreatedWarehouse: 'បានបង្កើតឃ្លាំងដោយជោគជ័យ',
        EditWarehouse: 'កែប្រែឃ្លាំង',
        AddWarehouse: 'បន្ថែមឃ្លាំង',
        WarehouseNameIsRequired: 'ត្រូវការឈ្មោះឃ្លាំង',
        EnterWarehouseName: 'បញ្ចូលឈ្មោះឃ្លាំង',
        EnterEmail: 'បញ្ចូលអ៊ីមែល',
        EnterPhoneNumber: 'បញ្ចូលលេខទូរស័ព្ទ',
        Location: 'ទីតាំង...',
        name: 'ឈ្មោះឃ្លាំង',
        email: 'អ៊ីមែល',
        phoneNumber: 'លេខទូរស័ព្ទ',
        location: 'ទីតាំង',
        ViewProducts: 'មើលផលិតផល',
        PageTitle: 'ឃ្លាំង',
        noWarehouse: "មិនមានឃ្លាំងណាមួយត្រូវនឹងការស្វែងរករបស់អ្នកទេ"
    },
    Assets: {
        headerTitle: 'ទ្រព្យសម្បត្តិ',
        addAssetMessage: 'បន្ថែមទ្រព្យសម្បត្តិទីនេះ។ ដើម្បីផ្តល់ទ្រព្យសម្បត្តិឱ្យបុគ្គលិក សូមចូលទៅកាន់ប្រវត្តិបុគ្គលិក។',
        addAsset: 'បន្ថែមទ្រព្យសម្បត្តិ',
        editAsset: 'កែប្រែទ្រព្យសម្បត្តិ',
        assetCode: 'កូដទ្រព្យសម្បត្តិ',
        assetName: 'ឈ្មោះទ្រព្យសម្បត្តិ',
        assetCategory: 'ប្រភេទទ្រព្យសម្បត្តិ',
        assetType: 'ប្រភេទទ្រព្យ',
        serialNumber: 'លេខស៊េរី',
        location: 'ទីតាំង',
        condition: 'ស្ថានភាព',
        selectCondition: 'ជ្រើសរើសស្ថានភាព',
        fair: 'មធ្យម',
        good: 'ល្អ',
        excellent: 'ល្អឥតខ្ចោះ',
        poor: 'អន់',
        notes: 'កំណត់ចំណាំ',
        submit: 'ដាក់ស្នើ',
        submitting: 'កំពុងដាក់ស្នើ...',
        noCategory: 'មិនមានប្រភេទទេ',
        selectCategory: 'ជ្រើសរើសប្រភេទ',
        addAssetCat: 'បន្ថែមប្រភេទទ្រព្យសម្បត្តិ',
        addAssetCatName: 'ឈ្មោះប្រភេទទ្រព្យសម្បត្តិ',
        edit: 'កែប្រែ',
        status: 'ស្ថានភាព',
        createdAt: 'បង្កើតនៅ',
        viewAsset: 'មើលទ្រព្យសម្បត្តិ',
        assignAsset: 'ចាត់ទុកទ្រព្យសម្បត្តិ',
        conditionRet: 'ស្ថានភាព (នៅពេលត្រឡប់)',
        searchSelectAssets: 'ស្វែងរក/ជ្រើសរើសទ្រព្យសម្បត្តិ',
        assetAssigned: 'បានចាត់ទុកទ្រព្យសម្បត្តិដោយជោគជ័យ',
        assetReturned: 'បានត្រឡប់ទ្រព្យសម្បត្តិដោយជោគជ័យ',
        selectAnAsset: 'សូមជ្រើសរើសទ្រព្យសម្បត្តិមួយ',
        action: 'សកម្មភាព',
        noAssetAssigned: 'មិនមានទ្រព្យសម្បត្តិត្រូវបានចាត់ទុក',
        reAssigned: 'ចាត់ទុកឡើងវិញ',
        assignedAssetsList: 'បញ្ជីទ្រព្យសម្បត្តិដែលបានចាត់ទុក',
        viewHistory: "មើលប្រវត្តិ",
        history: "ប្រវត្តិសម្បត្តិ",
        loadingHistory: "កំពុងផ្ទុកប្រវត្តិ...",
        loadingMore: "កំពុងផ្ទុកបន្ថែម...",
        dateTime: "កាលបរិច្ឆេទ និងម៉ោង",
        staff: "បុគ្គលិក",
        AssignedBy: "ចាត់តាំងដោយ",
        assign: "ចាត់តាំង",
        return: "ត្រឡប់",
        unknown: "មិនស្គាល់",
        noHistory: "គ្មានប្រវត្តិសម្រាប់ទ្រព្យសម្បត្តិនេះទេ។",
        enterReturnNote: "បញ្ចូលចំណាំសម្រាប់ការត្រឡប់",
        returnNote: "ចំណាំត្រឡប់",
        enterAssignNote: "បញ្ចូលចំណាំសម្រាប់ការចាត់តាំង",
        assignNote: "ចំណាំចាត់តាំង",
        AddNAC: "បន្ថែមប្រភេទទ្រព្យសម្បត្តិថ្មី",
        EditNAC: "កែសម្រួលប្រភេទទ្រព្យសម្បត្តិ",
        others: "ផ្សេងៗ"
    },

    LedgerTransaction: {
        ledgerDetails: 'ព័ត៌មានសៀវភៅគណនី',
        productName: 'ឈ្មោះផលិតផល',
        totalQty: 'បរិមាណសរុប',
        date: 'កាលបរិច្ឆេទ',
        receivedAmt: 'ចំនួនទទួលបាន',
        paid: 'បានបង់',
        discount: 'បញ្ចុះតម្លៃ',
        balance: 'សមតុល្យ',
        more: 'ច្រើនទៀត',
        total: 'សរុប',
        ledgerupdatedsuccessfully: 'បានធ្វើបច្ចុប្បន្នភាពសៀវភៅគណនីដោយជោគជ័យ',
        ledgeraddedsuccessfully: 'បានបន្ថែមសៀវភៅគណនីដោយជោគជ័យ',
        viewLedger: 'មើលសៀវភៅគណនី',
        edit: 'កែប្រែ',
        create: 'បង្កើត',
        Recieved: 'ទទួលបាន [ស្តុកចូល]',
        payMode: 'វិធីបង់ប្រាក់',
        Refno: 'លេខយោង'
    },

    ExtraField: {
        attachment: 'ឯកសារភ្ជាប់',
        acceptOnlyImg: 'ទទួលតែរូបភាពប៉ុណ្ណោះ។',
        addAttribute: 'បន្ថែមលក្ខណៈសម្បត្តិ',
        acceptImgAndDoc: "ទទួលយករូបភាព និងឯកសារ",
    },

    phoneInvoiceDownload: {
        Variant: "វ៉ារ្យ៉ង់",
        Warehouse: "ឃ្លាំង",
        Bin: "ធុង",
        Batch: "បាច់",
        Attributes: "លក្ខណៈសម្បត្តិ"
    },
    ImportExcel: {
        ImportStockfromExcel: "នាំចូលស្តុកពី Excel",
        DragDrop: "អូស និងទម្លាក់ឯកសារ Excel របស់អ្នកនៅទីនេះ ឬចុចដើម្បីជ្រើសរើស",
        DT: "ទាញយកគំរូ",
        GB: "ត្រឡប់ក្រោយ",
        Downloading: "កំពុងទាញយក...",
        ChangeFile: "ប្តូរឯកសារ",
        ReadingExcelfile: "កំពុងអានឯកសារ Excel...",
        Processing: "កំពុងដំណើរការ..."
    },
    stockForm: {
        recordPaymentNow: "កត់ត្រាការទូទាត់ឥឡូវនេះ",
        recordPaymentDescCustomer: "បញ្ចូលចំនួនទឹកប្រាក់ដែលអតិថិជនបានបង់",
        recordPaymentDescSupplier: "បញ្ចូលចំនួនទឹកប្រាក់ដែលអ្នកផ្គត់ផ្គង់បានបង់",
        managePayments: "គ្រប់គ្រងការទូទាត់",
        invoice: "វិក័យប័ត្រ",
        challan: "ប័ណ្ណដឹកជញ្ជូន",
        recordPayment: "កត់ត្រាការទូទាត់",
        payableAmount: "ចំនួនត្រូវបង់",
        paidAmount: "ចំនួនបានបង់",
        paymentMethod: "វិធីទូទាត់",
        paymentDate: "កាលបរិច្ឆេទទូទាត់",
        reference: "យោង",
        billId: "លេខវិក័យប័ត្រ",
        importExcel: "នាំចូលពី Excel",
        noThanks: "ទេ អរគុណ",
        checkHistory: "មើលប្រវត្តិ",
        wantViewHistory: "តើអ្នកចង់មើលប្រវត្តិទេ?",
        enterPayable: "បញ្ចូលចំនួនត្រូវបង់",
        enterPaid: "បញ្ចូលចំនួនបានបង់",
        selectPayment: "ជ្រើសរើសវិធីទូទាត់",
        attachment: "ឯកសារភ្ជាប់",
        note: "កំណត់ចំណាំ"
    },
    HistoryEdit: {
        products: "ផលិតផល",
        add_product: "បន្ថែមផលិតផល",
        paidAmountInvalidMessage: "ចំនួនបានបង់មិនអាចលើសចំនួនត្រូវបង់បានទេ",
        removingText: "ការលុបផលិតផលនេះនឹងត្រឡប់ការផ្លាស់ប្តូរស្តុកក្នុងប្រតិបត្តិការនេះ។",
        remove: "លុប"
    },
    ExcelProduct: {
        uploadFile: "ផ្ទុកឯកសារ",
        dragDrop: "អូស និងទម្លាក់ឯកសារ Excel ឬចុចដើម្បីផ្ទុកឡើង។",
        parsingFile: "កំពុងវិភាគឯកសារ",
        fileSelected: "បានជ្រើសរើសឯកសារ",
        reviewImportedData: "ពិនិត្យទិន្នន័យដែលបាននាំចូលខាងក្រោម។ ជួរឈរត្រូវបានផ្គូផ្គងដោយស្វ័យប្រវត្តិ ប្រសិនបើអាច។",
        changeFile: "ប្តូរឯកសារ",
        back: "ត្រឡប់ក្រោយ",
        invalidFileType: "សូមផ្ទុកឯកសារ Excel ត្រឹមត្រូវ (.xlsx ឬ .xls)",
        parseExcelError: "កំហុសវិភាគ Excel:",
        noData: "ឯកសារ Excel ដែលបានផ្ទុកឡើងមិនមានទិន្នន័យ។",
        failedToRead: "មិនអាចអានឯកសារ Excel បានទេ។ សូមព្យាយាមម្តងទៀត។",
        Nodata: "គ្មានទិន្នន័យ",
        unableToRead: "មិនអាចអានឯកសារ។",
        buyingMustNumber: "តម្លៃទិញត្រូវតែជាលេខ",
        sellingMustNumber: "តម្លៃលក់ត្រូវតែជាលេខ",
        mustBeNumber: "ត្រូវតែជាលេខ",
        bulkUploadfailed: "ការផ្ទុកជាក្រុមបរាជ័យ",
        importFromExcel: "នាំចូលពី Excel",
        generating: "កំពុងបង្កើត...",
        downloadTemplate: "ទាញយកគំរូ",
        uploading: "កំពុងផ្ទុកឡើង...",
        done: "រួចរាល់",
        requiredField: "{field} ត្រូវការជាចាំបាច់",
        bulkUpload: "ផ្ទុកជាក្រុម"
    },
    Discount: {
        overallDiscount: "បញ្ចុះតម្លៃសរុប",
        final: "សរុបចុងក្រោយ",
        balanceDue: "ចំនួននៅសល់",
        tax: "ពន្ធ"
    },
    ProductForm: {
        barcodeQuantity: "បញ្ចូលបរិមាណបាកូដ",
        baseUnit: "ឯកតាមូលដ្ឋាន (សំខាន់)",
        addSecondaryUnit: "បន្ថែមឯកតារង?",
        selectUnit: "ជ្រើសរើសឯកតា",
        subUnitDetails: "ព័ត៌មានលម្អិតឯកតារង",
        subUnit: "ឯកតារង",
        selectSubUnit: "ជ្រើសរើសឯកតារង",
        conversionRate: "អត្រាបម្លែង",
        exampleLogic: "តក្កវិជ្ជាឧទាហរណ៍៖",
        example: "ប្រសិនបើអ្នកលក់ប៊ិចជាប្រអប់ សូមកំណត់ឯកតាមូលដ្ឋានជា ប្រអប់ ហើយបន្ថែមឯកតារង (ដុំ) ជាមួយអត្រាបម្លែង 50។ នេះមានន័យថា ប្រអប់ 1 មាន 50 ដុំ។",
        basePrice: "តម្លៃមូលដ្ឋាន"
    },
    barcode: {
        settings: 'ការកំណត់បារកូដ',
        labelSize: 'ទំហំស្លាក',
        customSize: 'ទំហំផ្ទាល់ខ្លួន...',
        widthMm: 'ទទឹង (មម)',
        heightMm: 'កម្ពស់ (មម)',
        showPrice: 'បង្ហាញតម្លៃលក់លើស្លាក',
        noPrices: 'មិនទាន់មានការកំណត់តម្លៃលក់សម្រាប់ផលិតផលនេះទេ។',
        preview: 'មើលជាមុន',
        generate: 'បង្កើត',
        label: 'ស្លាក',
        singlePage: 'ទំព័រតែមួយ',
        downloadOptions: 'ជម្រើសទាញយក',
        chooseLayout: 'ជ្រើសរើសប្លង់សម្រាប់បារកូដ',
        allInSinglePage: 'បន្ថែមបារកូដទាំងអស់ក្នុងទំព័រតែមួយ។',
        allInA4Grid: 'ទាំងអស់ក្នុងទំព័រតែមួយ',
        allInA4GridSub: 'រៀបចំបារកូដទាំងអស់ក្នុងក្រឡាចត្រង្គ A4',
        onePerPage: 'មួយក្នុងមួយទំព័រ',
        onePerPageSub: 'បារកូដនីមួយៗនៅលើទំព័រស្លាកផ្ទាល់ខ្លួន'
    },

    TransferItem: {
        transferItem: "ផ្ទេរទំនិញ",
        Date: "កាលបរិច្ឆេទ",
        Reason: "មូលហេតុ",
        enterReason: "បញ្ចូលមូលហេតុ",
        Name: "ឈ្មោះ",
        QuantityTransfered: "បរិមាណដែលបានផ្ទេរ",
        SWarehouse: "ឃ្លាំងប្រភព",
        SelectSWarehouse: "ជ្រើសរើសឃ្លាំងប្រភព",
        DWarehouse: "ឃ្លាំងគោលដៅ",
        SelectDWarehouse: "ជ្រើសរើសឃ្លាំងគោលដៅ",
        CreatedBy: "បង្កើតដោយ",
        CreatedTime: "ម៉ោងបង្កើត",
        UpdatedTime: "ម៉ោងធ្វើបច្ចុប្បន្នភាព",
        NoOrderFound: "រកមិនឃើញការបញ្ជាទិញ",
        New: "ថ្មី",
        WarehouseItemTransfer: "ផ្ទេរទំនិញឃ្លាំង",
        TotalTransfers: "ការផ្ទេរសរុប",
        EnterReason: "បញ្ចូលមូលហេតុ",
        ItemDetails: "ព័ត៌មានលម្អិតទំនិញ",
        CurrentAvailable: "មានស្រាប់បច្ចុប្បន្ន",
        TransferQty: "បរិមាណផ្ទេរ",
        SStock: "ស្តុកប្រភព",
        DStock: "ស្តុកគោលដៅ",
        addDescription: "បន្ថែមការពិពណ៌នាទំនិញ",
        selectVariant: "ជ្រើសរើសវ៉ារ្យ៉ង់",
        addNewRow: "បន្ថែមជួរថ្មី",
        typeOrSelectItem: "វាយបញ្ចូលដើម្បីស្វែងរក",
        scrollToLoadMore: "រុញដើម្បីផ្ទុកបន្ថែម",
        noProductsFound: "រកមិនឃើញផលិតផល",
        selectWarehouse: "ជ្រើសរើសឃ្លាំង"
    },
    Sku: {
        searchSelectProduct: "ស្វែងរក / ជ្រើសរើសផលិតផល",
        searchSelectSku: "ស្វែងរក / ជ្រើសរើស SKU",
        noSkuFound: "រកមិនឃើញ SKU"
    },
    HistoryPage: {
        addFilter: "បន្ថែមតម្រង",
        filtersActive: "តម្រងទាំងអស់សកម្ម",
        noProducts: "គ្មានផលិតផល",
        download: "ទាញយក",
        recentlyUpdated: "បានធ្វើបច្ចុប្បន្នភាពថ្មីៗ",
    },
    StockPage: {
        challanNumber: "លេខឯកសារ",
        subTotal: "សរុបរង",
        totalTaxes: "សរុប និង ពន្ធ",
        taxInclusive: "រួមបញ្ចូលពន្ធ",
        discountedValue: "តម្លៃបញ្ចុះ",
        taxValue: "តម្លៃពន្ធ",
        totalAmount: "ចំនួនសរុប",
        close: "បិទ",
        addTax: "បន្ថែមពន្ធ",
        label: "ស្លាក",
        enterLabel: "បញ្ចូលស្លាក",
        taxRate: "អត្រាពន្ធ",
        enterTaxRate: "បញ្ចូលអត្រាពន្ធ",
        selectTaxRate: "ជ្រើសរើសអត្រាពន្ធ",
        addNewTax: "បន្ថែមអត្រាពន្ធថ្មី",
        discountProducts: "តម្លៃបញ្ចុះ (ផលិតផល)",
        taxProducts: "តម្លៃពន្ធ (ផលិតផល)",
        clickAddPayment: "ចុចដើម្បីបន្ថែមការទូទាត់",
        paidGreaterPayable: "ចំនួនដែលបានបង់ មិនអាចលើសចំនួនត្រូវបង់បានទេ",
        vendorCompulsory: "ត្រូវការអ្នកផ្គត់ផ្គង់ដើម្បីកត់ត្រាការទូទាត់",
        customerCompulsory: "ត្រូវការអតិថិជនដើម្បីកត់ត្រាការទូទាត់",
        updateInvoiceFormat: "ធ្វើបច្ចុប្បន្នភាពទ្រង់ទ្រាយវិក្កយបត្រ",
        updateChallanFormat: "ធ្វើបច្ចុប្បន្នភាពទ្រង់ទ្រាយឯកសារ",
        addPrefix: "បន្ថែមបុព្វបទ",
        prefix: "បុព្វបទ"
    },
    EditHistoryPage: {
        search_by_notes: "ស្វែងរកតាមកំណត់ចំណាំ",
        alertMessage: "ការផ្លាស់ប្តូរនេះត្រូវបានកត់ត្រាតែ​ក្នុងប្រវត្តិប៉ុណ្ណោះ ហើយមិនប៉ះពាល់ដល់ស្តុកបច្ចុប្បន្នទេ។",
        paymentDetails: "ព័ត៌មានការទូទាត់",
        units: "ឯកតា",
        customLabels: "ស្លាកផ្ទាល់ខ្លួន",
        value: "តម្លៃ",
        Order_Info: "ព័ត៌មានការបញ្ជាទិញ",
        percentage: "ភាគរយ",
        Stock_updates_on_submit: "ធ្វើបច្ចុប្បន្នភាពស្តុកនៅពេលដាក់ស្នើ",
        Summary: "សង្ខេប"
    },
    historyCard: {
        paid: "បានបង់",
        partiallyPaid: "បានបង់មួយផ្នែក",
        billDate: "កាលបរិច្ឆេទវិក្កយបត្រ",
        productDetails: "ព័ត៌មានផលិតផល",
        paymentsHistory: "ប្រវត្តិការទូទាត់",
        updatePayment: "ធ្វើបច្ចុប្បន្នភាពការទូទាត់",
        discounts: "បញ្ចុះតម្លៃ",
        inclusive: "(រួម)",
        discountOverall: "តម្លៃបញ្ចុះ (សរុប)",
        dueAmount: "ចំនួនត្រូវបង់",
        enterPaid: "បញ្ចូលចំនួនដែលបានបង់",
        enterReference: "បញ្ចូលយោង",
        enterNote: "បញ្ចូលកំណត់ចំណាំ",
        enterInvoice: "បញ្ចូលវិក្កយបត្រ",
        enterChallan: "បញ្ចូលឯកសារ",
        edit: "បានកែសម្រួល",
        duplicateSku: "រកឃើញ SKU ស្ទួន",
        uploadedSuccessfully: "ផលិតផលទាំងអស់ត្រូវបានផ្ទុកឡើងដោយជោគជ័យ!",
        uploadCompleteIssues: "ការផ្ទុកឡើងបានបញ្ចប់ដោយមានបញ្ហា",
        uploaded_products: "បានផ្ទុកឡើង {count} ផលិតផល។",
        failed_products: "{count} បានបរាជ័យ។",
        failed_items: "ធាតុបរាជ័យ:"
    },
    printInvoice: {
        billTo: "វិក្កយបត្រទៅ",
        ref: "លេខយោង",
        mode: "របៀប",
        date: "កាលបរិច្ឆេទ",
        amount: "ចំនួន",
        totalPaid: "សរុបដែលបានបង់"
    },
    Contact: {
        supplier_required: "ត្រូវការអ្នកផ្គត់ផ្គង់សម្រាប់ការបញ្ចូលស្តុក",
        customer_required: "ត្រូវការអតិថិជនសម្រាប់ការចេញស្តុក",
        key: "សោ",
        editHistory: "កែសម្រួលប្រវត្តិ",
        loading: "កំពុងផ្ទុក..."
    },
    AW: {
        availablewarehouse: "ឃ្លាំងដែលអាចប្រើបាន",
        visibilityManagement: 'ការគ្រប់គ្រងលទ្ធភាពមើលឃើញ',
        availablewarehouses: "ឃ្លាំងដែលអាចប្រើបាន",
        Active: "សកម្ម",
        LWarehouse: "កំពុងផ្ទុកឃ្លាំង...",
        NWForthisProduct: "រកមិនឃើញឃ្លាំងសម្រាប់ផលិតផលនេះ។",
        of: "នៃ",
        WarehouseAvailabilty: "ភាពអាចប្រើបានរបស់ឃ្លាំង",
    },
    Currency: {
        searchCurrency: "ស្វែងរករូបិយប័ណ្ណ...",
        addCurrency: "បន្ថែមរូបិយប័ណ្ណ",
        addNewCurrency: "បន្ថែមរូបិយប័ណ្ណថ្មី",
        editCurrency: "កែប្រែរូបិយប័ណ្ណ",
        currencySymbol: "និមិត្តសញ្ញារូបិយប័ណ្ណ",
        currencyName: "ឈ្មោះរូបិយប័ណ្ណ",
        enterCurrencySymbol: "បញ្ចូលនិមិត្តសញ្ញារូបិយប័ណ្ណ",
        enterCurrencyName: "បញ្ចូលឈ្មោះរូបិយប័ណ្ណ"
    },

    NewReportLang: {
        DM: "ចលនាប្រចាំថ្ងៃ",
        WR: "របាយការណ៍ឃ្លាំង",
        PDM: "ចលនាផលិតផលប្រចាំថ្ងៃ",
        TBP: "តម្លៃទិញសរុប",
        TPQ: "បរិមាណផលិតផលសរុប",
        TP: "ផលិតផលសរុប",
        CS: "ស្តុកបច្ចុប្បន្ន",
        IV: "តម្លៃស្តុក",
        DA: "មធ្យមភាគប្រចាំថ្ងៃ",
        TSI: "ស្តុកចូលសរុប",
        TSO: "ស្តុកចេញសរុប",
        TOR: "អត្រាវិលជុំ",
        Tv: "តម្លៃសរុប",
        AST: "ការតាមដាន SKU សកម្ម",
        UT: "ចំនួនត្រូវបានតាមដាន",
        SL: "កម្រិតស្តុក",
        Value: "តម្លៃ",
        IO: "ចូល/ចេញ",
        T: "វិលជុំ",
        unitsD: "ឯកតា/ថ្ងៃ",

        Sort: "រៀបចំ",
        Sort_by: "រៀបចំតាម",
        Units_available: "ឯកតាដែលមាន",
        Units_unavailable: "ឯកតាដែលអស់",
        Current_assets: "ទ្រព្យសកម្មបច្ចុប្បន្ន",
        Search: "ស្វែងរក",

        available: "មាន",
        assigned: "បានកំណត់",

        AYSWD: "តើអ្នកប្រាកដជាចង់លុបទេ?",
        PTS: "ផលិតផលត្រូវបានផ្ទេរដោយជោគជ័យ",

        AUS: "ទ្រព្យសកម្មត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
        ACS: "ទ្រព្យសកម្មត្រូវបានបង្កើតដោយជោគជ័យ",
        VSP: "មើលតម្លៃលក់",
        HUS: "ប្រវត្តិត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
    },
    ReplacementReturn: {
        selectProduct: "សូមជ្រើសរើសផលិតផល",
        selectReplacementProduct: "សូមជ្រើសរើសផលិតផលជំនួសយ៉ាងហោចណាស់មួយ",
        validQuantity: "សូមបញ្ចូលបរិមាណត្រឡប់មកវិញដែលត្រឹមត្រូវ",
        replacedSuccessfully: "ផលិតផលត្រូវបានជំនួសដោយជោគជ័យ",
        returnSuccessfully: "ផលិតផលត្រូវបានត្រឡប់ដោយជោគជ័យ",
        failedProcess: "បរាជ័យក្នុងការដំណើរការ។ សូមព្យាយាមម្តងទៀត។",
        return: "ត្រឡប់",
        replace: "ជំនួស",
        typeSelectProduct: "វាយឬជ្រើសរើសផលិតផល...",
        returnQuantity: "បរិមាណត្រឡប់",
        enterQuantity: "បញ្ចូលបរិមាណ",
        replacementDate: "កាលបរិច្ឆេទជំនួស",
        returnDate: "កាលបរិច្ឆេទត្រឡប់",
        chooseCustomer: "ជ្រើសរើសអតិថិជន",
        additionalNotes: "បន្ថែមកំណត់ចំណាំបន្ថែម...",
        replacementProducts: "ផលិតផលជំនួស",
        addProducts: "បន្ថែមផលិតផលបន្ថែម",
        tapSelect: "ចុចដើម្បីជ្រើសរើសពីផលិតផលដែលមាន",
        currently: "បច្ចុប្បន្ន",
        item: "ទំនិញ",
        items: "ទំនិញ",
        selected: "បានជ្រើសរើស",
        selectedItems: "ទំនិញដែលបានជ្រើសរើស",
        hideDetails: "លាក់ព័ត៌មានលម្អិតបន្ថែម",
        showDetails: "បង្ហាញព័ត៌មានលម្អិតបន្ថែម",
        product: "ផលិតផល",
        priceLevel: "ជ្រើសរើសកម្រិតតម្លៃ",
        customPrice: "បញ្ចូលតម្លៃផ្ទាល់ខ្លួន",
        noReplaceHistory: "រកមិនឃើញប្រវត្តិជំនួស",
        replaceReturn: "ជំនួស និង ត្រឡប់មកវិញ",
        replaceReturnHistory: "ប្រវត្តិនៃការជំនួស និងការត្រឡប់"
    },
    OtherComponent: {
        mfgHistoryTitle: "ប្រវត្តិនៃការផលិត",
        mfgHistoryDesc: "តាមដានផលិតផលស្តុកដែលបានផលិត",
        dailyOperation: "ប្រតិបត្តិការប្រចាំថ្ងៃ",
        freqUsed: "សកម្មភាពដែលប្រើញឹកញាប់ដើម្បីធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាយ៉ាងលឿន",
        manageCategory: "គ្រប់គ្រងប្រភេទ",
        organizeCaterory: "រៀបចំ និងគ្រប់គ្រងប្រភេទផលិតផល ចំណាយ និងទ្រព្យសម្បត្តិ",
        businessRecord: "កំណត់ត្រាអាជីវកម្ម",
        organizeRecord: "រៀបចំ និងគ្រប់គ្រងកំណត់ត្រាអាជីវកម្មរបស់អ្នក",
        trackHistory: "តាមដានប្រវត្តិ",
        completeTracking: "ប្រវត្តិពេញលេញសម្រាប់ការត្រួតពិនិត្យ និងការតាមដាន"
    },
    no_permission_dialog: {
        title: 'គ្មានសិទ្ធិ',
        historyDescription: "អ្នកមិនមានសិទ្ធិមើលប្រវត្តិប្រតិបត្តិការទេ។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។",
        replacementHistoryDescription: "អ្នកមិនមានសិទ្ធិមើលប្រវត្តិការជំនួស និងត្រឡប់ទេ។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។",
        transferHistoryDescription: "អ្នកមិនមានសិទ្ធិមើលប្រវត្តិផ្ទេរឃ្លាំងទេ។ សូមទាក់ទងអ្នកគ្រប់គ្រងរបស់អ្នក។"
    },
    OthersHistory: {
        title: "គ្រប់គ្រងប្រវត្តិ",
        transferHistory: "គ្រប់គ្រងប្រវត្តិផ្ទេរ",
        transactionHistory: "គ្រប់គ្រងប្រវត្តិប្រតិបត្តិការ",
        replacementHistory: "គ្រប់គ្រងប្រវត្តិការជំនួស និងត្រឡប់"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "រកមើល និងទិញផលិតផលដែលអាជីវកម្មបានចែករំលែក។",
        description: "រកមើលផលិតផលដែលអាជីវកម្មបានចែករំលែក។",
        productsAvailable: "ផលិតផលដែលមាន",
        noImageAvailable: "មិនមានរូបភាព",
        productDetails: "ព័ត៌មានលម្អិតផលិតផល",
        inStock: "មានក្នុងស្តុក",
        availableVariants: "ជម្រើសដែលមាន",
        options: "ជម្រើស",
        orders: "ការបញ្ជាទិញ"
        ,
        searchProducts: "ស្វែងរកផលិតផល...",
        noProductsFound: "រកមិនឃើញផលិតផល",
        tryDifferentKeyword: "សាកល្បងស្វែងរកពាក្យផ្សេង",
        variants: "បំរែបំរួល",
        stock: "ស្តុក",
        cart: "កន្ត្រក",
        products: "ផលិតផល",
        viewCart: "មើលកន្ត្រក",
        backToProducts: "ត្រឡប់ទៅផលិតផល",
        yourCart: "កន្ត្រករបស់អ្នក",
        clear: "សម្អាត",
        cartEmpty: "កន្ត្រករបស់អ្នកទទេ",
        cartEmptyDesc: "រុករកកាតាឡុកហើយបន្ថែមផលិតផលដែលអ្នកចង់បញ្ជាទិញ។",
        browseProducts: "រុករកផលិតផល",
        selectedItems: "របស់ដែលបានជ្រើសរើស",
        itemInCart: "របស់ក្នុងកន្ត្រក",
        itemsInCart: "របស់ក្នុងកន្ត្រក",
        customerDeliveryDetails: "ព័ត៌មានអតិថិជន និងការដឹកជញ្ជូន",
        fullName: "ឈ្មោះពេញ",
        enterFullName: "បញ្ចូលឈ្មោះពេញរបស់អ្នក",
        deliveryAddress: "អាសយដ្ឋានដឹកជញ្ជូន",
        addressPlaceholder: "ផ្លូវ អគារ ទីក្រុង លេខកូដប្រៃសណីយ៍...",
        orderNote: "កំណត់ចំណាំបញ្ជាទិញ (ជាជម្រើស)",
        orderNotePlaceholder: "ការណែនាំពិសេសឬកំណត់ចំណាំដឹកជញ្ជូន...",
        paymentMode: "របៀបបង់ប្រាក់",
        subtotal: "អនុសរុប",
        items: "របស់",
        totalAmount: "ចំនួនសរុប",
        orderOnWhatsApp: "បញ្ជាទិញតាម WhatsApp 📲",
        orderPlaced: "បញ្ជាទិញបានជោគជ័យ! 🎉",
        orderPlacedDesc: "ការបញ្ជាទិញរបស់អ្នកត្រូវបានកត់ត្រាហើយ WhatsApp បានបើក។",
        continueShopping: "បន្តการทิញទំនិញ 🛍️",
        cartEmptyTitle: "កន្ត្រកទទេ",
        cartEmptyToast: "សូមបន្ថែមផលិតផលមុនពេលចេញ។",
        incompleteTitle: "ព័ត៌មានមិនពេញលេញ",
        incompleteToast: "សូមបំពេញគ្រប់វាលដែលទាមទារ។",
        nameRequired: "ឈ្មោះពេញត្រូវបានទាមទារ",
        addressRequired: "អាសយដ្ឋានដឹកជញ្ជូនត្រូវបានទាមទារ",
        catalogUnavailable: "កាតាឡុកមិនអាចប្រើបានបច្ចុប្បន្ន",
        catalogUnavailableDesc: "កាតាឡុកនេះមិនសកម្មទេ។ សូមទាក់ទងអាជីវកម្ម។",
        invalidCatalogLink: "តំណកាតាឡុកមិនត្រឹមត្រូវ 🚫",
        invalidCatalogDesc: "ទំព័រកាតាឡុកនេះខ្វះព័ត៌មានចាំបាច់។",
        missing: "បាត់",
        catalogSlug: "កូដកាតាឡុក",
        goBackHome: "ត្រឡប់ទៅទំព័រដើម",
        inventoryManagement: "គ្រប់គ្រងស្តុក និងវិក្កយបត្រ 🚀 Simply",
        enter: "បញ្ចូល",
        select: "ជ្រើសរើស",
        // Catalog Order translations
        catalogOrders: 'ការបញ្ជាទិញកាតាឡុក',
        pending: 'កំពុងរង់ចាំ',
        converted: 'បានបម្លែង',
        cancelled: 'បានលុបចោល',
        totalRevenue: 'តម្លៃសរុប',
        totalCatalogOrders: 'ការបញ្ជាទិញអនឡាញសរុប',
        convertToSalesOrder: 'បម្លែងទៅការបញ្ជាទិញលក់',
        date: 'កាលបរិច្ឆេទ',
        status: 'ស្ថានភាព',
        action: 'សកម្មភាព',
        searchOrders: 'ស្វែងរកអតិថិជន ឬលេខទូរស័ព្ទ...',
        noMatchingOrders: 'រកមិនឃើញការបញ្ជាទិញដែលត្រូវគ្នា',
        noStatusOrders: 'រកមិនឃើញការបញ្ជាទិញ {status}',
        tryDifferentSearch: 'សាកល្បងស្វែងរកដោយប្រើឈ្មោះអតិថិជន ឬលេខទូរស័ព្ទផ្សេង។',
        noOrdersWithStatus: 'បច្ចុប្បន្នមិនមានការបញ្ជាទិញដែលមានស្ថានភាព {status} ទេ។',
        noOrdersYet: 'មិនទាន់មានការបញ្ជាទិញកាតាឡុក',
        noOrdersDescription: 'ការបញ្ជាទិញពីកាតាឡុកអនឡាញរបស់អ្នកនឹងបង្ហាញនៅទីនេះ។',
        guestCustomer: 'អតិថិជនភ្ញៀវ',
        item: 'ទំនិញ',
        moreItems: '+{count} ទៀត',
        viewDetails: 'មើលព័ត៌មានលម្អិត',
        viewSalesOrder: 'មើលការបញ្ជាទិញលក់',
        cancelOrder: 'បោះបង់ការបញ្ជាទិញ',
        confirmCancelTitle: 'បោះបង់ការបញ្ជាទិញកាតាឡុក?',
        confirmCancelOrder: 'តើអ្នកប្រាកដថាចង់បោះបង់ការបញ្ជាទិញនេះទេ? សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ។',
        keepOrder: 'ទេ រក្សាការបញ្ជាទិញ',
        confirmCancelAction: 'បាទ/ចាស បោះបង់ការបញ្ជាទិញ',
        orderNotFound: 'រកមិនឃើញការបញ្ជាទិញកាតាឡុក',
        orderNotFoundDescription: 'រកមិនឃើញការបញ្ជាទិញនេះ ឬអ្នកអាចមិនមានសិទ្ធិមើលវា។',
        backToCatalogOrders: 'ត្រឡប់ទៅការបញ្ជាទិញកាតាឡុក',
        placedOn: 'បានបញ្ជាទិញនៅ',
        totalItems: 'ទំនិញសរុប',
        orderedProducts: 'ផលិតផលដែលបានបញ្ជាទិញ',
        itemDetails: 'ព័ត៌មានលម្អិតទំនិញ',
        quantity: 'បរិមាណ',
        unitPrice: 'តម្លៃឯកតា',
        total: 'សរុប',
        variant: 'ជម្រើស',
        customerInformation: 'ព័ត៌មានអតិថិជន',
        additionalFields: 'វាលបន្ថែម',
        fields: 'វាល',
    },
    stockNew: {
        Npay: "មិនទាន់មានផលិតផលបន្ថែមទេ",
        emptydesc: "ជ្រើសរើសផលិតផលពីកាតាឡុករបស់អ្នក ហើយបញ្ចូលបរិមាណចូលដើម្បីកត់ត្រាស្តុក។",
        tipText: "គន្លឹះ៖ អ្នកអាចផ្ទុកឡើងឯកសារ excel បានដែរ",
        OT: "សរុបសម្បទាន",
        Collapse: "បង្រួម"
    },
    BatchLocal: {
        BatchName: "ឈ្មោះបាច់",
        EnterBatchName: "បញ្ចូលឈ្មោះបាច់",
        EnterNotes: "បញ្ចូលកំណត់ត្រា",
        ExpiredDate: "កាលបរិច្ឆេទផុតកំណត់",
        Selectexpireddate: "ជ្រើសរើសកាលបរិច្ឆេទផុតកំណត់",
        BatchStatus: "ស្ថានភាពបាច់",
        CreatedDate: "កាលបរិច្ឆេទបង្កើត",
        Areyousureyouwanttodeletethisbatch: "តើអ្នកពិតជាចង់លុបបាច់នេះមែនទេ?",
        Youhavencreatedanybatchforthisproduct: "អ្នកមិនទាន់បានបង្កើតបាច់ណាមួយសម្រាប់ផលិតផលនេះនៅឡើយទេ។",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "បង្កើតបាច់ដំបូងរបស់អ្នកដើម្បីចាប់ផ្តើមតាមដានស្តុកតាមលត់ និងកាលបរិច្ឆេទផុតកំណត់។",
        Nobatchesyet: "មិនទាន់មានបាច់នៅឡើយទេ",
        Whatisbatchmanagement: "ការគ្រប់គ្រងបាច់ជាអ្វី?",
        Howithelpsyourbusiness: "វាជួយអាជីវកម្មរបស់អ្នកយ៉ាងដូចម្តេច",
        Trackbylotnumber: "តាមដានតាមលេខលត់",
        Trackbylotnumberdesc: "ដាក់ជាក្រុមស្តុកតាមបាច់របស់អ្នកផលិត ដើម្បីឱ្យអ្នកតែងតែដឹងថាឯកតាមកពីលត់ណា។",
        Expirydatecontrol: "ការគ្រប់គ្រងកាលបរិច្ឆេទផុតកំណត់",
        Expirydatecontroldesc: "ទទួលបានការជូនដំណឹងមុនពេលស្តុកផុតកំណត់។ លក់បាច់ចាស់ជាមុនសិន និងកាត់បន្ថយកាកសំណល់ដោយស្វ័យប្រវត្តិ។",
        Fulltraceability: "ការតាមដានពេញលេញ",
        Fulltraceabilitydesc: "មើលឱ្យច្បាស់ថាបាច់ណាត្រូវបានប្រើប្រាស់ក្នុងរាល់ប្រតិបត្តិការ — ល្អសម្រាប់ការសវនកម្ម និងការហូតយកមកវិញ។",
        Supplierwisestock: "ស្តុកតាមអ្នកផ្គត់ផ្គង់",
        Supplierwisestockdesc: "បំបែកស្តុកពីអ្នកផ្គត់ផ្គង់ផ្សេងៗគ្នា ទោះបីជាផលិតផលដូចគ្នាក៏ដោយ។ ប្រៀបធៀបគុណភាពតាមបាច់។",
        Createyourfirstbatchbutton: "បង្កើតបាច់ដំបូងរបស់អ្នក",
        Nomatchesfound: "រកមិនឃើញលទ្ធផលដែលត្រូវគ្នា",
        NomatchesfounddescBefore: "យើងមិនអាចរកឃើញបាច់ណាដែលត្រូវគ្នានឹង ",
        NomatchesfounddescAfter: " ទេ។",
        Clearsearch: "លុបការស្វែងរក",
        Nohistoryfoundthisbatch: "រកមិនឃើញប្រវត្តិសម្រាប់បាច់នេះទេ",
        ComprehensiveDetails: "ព័ត៌មានលម្អិតទាំងអស់",
        History: "ប្រវត្តិ",
        InBatch: "នៅក្នុងបាច់",
        Noproductfoundinthisbatch: "រកមិនឃើញផលិតផលណាមួយនៅក្នុងបាច់នេះទេ",
        SelectBatch: "ជ្រើសរើសបាច់",
        available: "មាន",
        Searchbatches: "ស្វែងរកបាច់...",
        Expires: "ផុតកំណត់",
        Nobatchesfound: "រកមិនឃើញបាច់ទេ",
        ManageBatches: "គ្រប់គ្រងបាច់",
        Batchmanagement: "ការគ្រប់គ្រងបាច់",
        Trackstockexpiry: "តាមដានស្តុកតាមបាច់ និងកាលបរិច្ឆេទផុតកំណត់",
        Turnoffbatchmanagement: "បិទការគ្រប់គ្រងបាច់?",
        Yourgsafe: "ទិន្នន័យបាច់ដែលមានស្រាប់របស់អ្នកនៅតែមានសុវត្ថិភាព។",
        Reenableanytimefrom: "អ្នកអាចបើកឡើងវិញបានគ្រប់ពេលពី",
        Otherstab: "ផ្ទាំងផ្សេងៗ",
        AddBatch: "បន្ថែមបាច់",
        Total: "សរុប",
        AssignProduct: "ផ្ដល់ផលិតផល",
        EditProductAssignment: "កែសម្រួលការផ្ដល់ផលិតផល",
        AssignProducttoBatch: "ផ្ដល់ផលិតផលទៅបាច់",
        Updateproductconfiguration: "ធ្វើបច្ចុប្បន្នភាពការកំណត់រចនាសម្ព័ន្ធផលិតផល",
        Step1of2: "ជំហានទី ១ នៃ ២",
        Step2of2: "ជំហានទី ២ នៃ ២",
        Selectvariantwarehouse: "ជ្រើសរើសវ៉ារ្យ៉ង់ & ឃ្លាំង",
        SelectedProduct: "ផលិតផលដែលបានជ្រើសរើស",
        AssignQuantity: "ផ្ដល់បរិមាណ",
        BatchInfo: "ព័ត៌មានបាច់",
        Wecouldnthisproductidentifier: "យើងមិនអាចរកឃើញបាច់ណាដែលទាក់ទងនឹងអត្តសញ្ញាណផលិតផលនេះទេ។",
        NoActiveBatches: "គ្មានបាច់សកម្ម",
        Endofresults: "ចុងបញ្ចប់នៃលទ្ធផល",
        Expiry: "ការផុតកំណត់",
        BatchManagementDescription: "តាមដានស្តុកតាមលេខបាច់និងកាលបរិច្ឆេទផុតកំណត់។ ធានាឱ្យមានលំដាប់ LIFO / FEFO ត្រឹមត្រូវរាល់ពេលចេញស្តុក - មិនចាំបាច់រើសដោយដៃឡើយ។",
        Expiryalerts: "ការដាស់តឿនផុតកំណត់",
        Autonotifications: "ការជូនដំណឹងស្វ័យប្រវត្ត",
        LIFOsorting: "ការតម្រៀបតាម LIFO / FEFO",
        Smartstockflow: "លំហូរស្តុកឆ្លាតវៃ",
        Perout: "ការចេញស្តុកតាមបាច់",
        Precisiontracking: "ការតាមដានច្បាស់លាស់",
        NeedsReview: "ត្រូវការពិនិត្យឡើងវិញ",
        Pending: "កំពុងរង់ចាំ",
        Rejected: "បានបដិសេធ",
        Approved: "បានអនុម័ត",
        WaitingForApproval: "កំពុងរង់ចាំការអនុម័ត",
        WaitingForApprovalDesc: "ម្ចាស់របស់អ្នកនឹងពិនិត្យ និងអនុម័តបាច់នេះឆាប់ៗនេះ។",
        BatchRejected: "បាច់ត្រូវបានបដិសេធ",
        BatchRejectedDesc: "ម្ចាស់របស់អ្នកបានបដិសេធបាច់នេះ។",
        Reason: "ហេតុផល",
        Approve: "អនុម័ត",
        Reject: "បដិសេធ",
        ConfirmApproveTitle: "អនុម័តបាច់",
        ConfirmRejectTitle: "បដិសេធបាច់",
        ConfirmApprovalAction: "តើអ្នកប្រាកដថាចង់ {action} បាច់នេះទេ? សកម្មភាពនេះនឹងធ្វើបច្ចុប្បន្នភាពស្ថានភាពរបស់វា។",
        ReasonOptional: "ហេតុផល (ជាជម្រើស)",
        EnterReasonPlaceholder: "បញ្ចូលហេតុផលសម្រាប់ {action} (ជាជម្រើស)",
        Processing: "កំពុងដំណើរការ...",
        BatchActivatedSuccess: "បាច់ត្រូវបានដំណើរការជោគជ័យ",
        BatchDeactivatedSuccess: "បាច់ត្រូវបានបិទជោគជ័យ",
        BatchDeletedSuccess: "បាច់ត្រូវបានលុបជោគជ័យ",
        BatchApprovedSuccess: "បាច់ត្រូវបានអនុម័តជោគជ័យ",
        BatchRejectedSuccess: "បាច់ត្រូវបានបដិសេធជោគជ័យ",
        SearchByBatchName: "ស្វែងរកតាមឈ្មោះបាច់...",
        YesTurnOff: "បាទ/ចាស បិទ",
        KeepItOn: "រក្សាឲ្យបើក"
    },
    PurchaseSales: {
        CancelOrder: "បោះបង់ការបញ្ជាទិញ",
        ReopenOrder: "បើកការបញ្ជាទិញឡើងវិញ",
        Reopen: "បើកឡើងវិញ",
        ConfirmCancelOrder: "តើអ្នកប្រាកដថាចង់បោះបង់ការបញ្ជាទិញនេះទេ?",
        ConfirmReopenOrder: "តើអ្នកប្រាកដថាចង់បើកការបញ្ជាទិញនេះឡើងវិញទេ?",
        OrderCancelledSuccessfully: "ការបញ្ជាទិញត្រូវបានបោះបង់ដោយជោគជ័យ។",
        OrderReopenedSuccessfully: "ការបញ្ជាទិញត្រូវបានបើកឡើងវិញដោយជោគជ័យ។",
        CancelledBy: "បោះបង់ដោយ",
        Cancelled: "បានបោះបង់",
        ConvertPriceBasedOnUnitConversion: "បម្លែងតម្លៃផ្អែកលើការបម្លែងឯកតា",
        MarkPaymentAsPending: "សម្គាល់ការទូទាត់ថាកំពុងរង់ចាំ",
        PendingReceivableDesc: "ចំនួនទឹកប្រាក់បានកត់ត្រាជាប្រាក់ត្រូវទទួល។ កត់ត្រាការទូទាត់នៅពេលទទួលបាន។",
        PendingPayableDesc: "ចំនួនទឹកប្រាក់បានកត់ត្រាជាប្រាក់ត្រូវបង់។ កត់ត្រាការទូទាត់នៅពេលបង់រួច។",
        SelectCustomerFirst: "សូមជ្រើសរើសអតិថិជនជាមុន",
        SelectSupplierFirst: "សូមជ្រើសរើសអ្នកផ្គត់ផ្គង់ជាមុន",
        SelectItemsFirst: "សូមជ្រើសរើសទំនិញយ៉ាងហោចណាស់មួយជាមុនសិន",
        PaymentMarkedPendingDesc: "ការទូទាត់ត្រូវបានសម្គាល់ថាកំពុងរង់ចាំ។ ដោះធីក 'សម្គាល់ការទូទាត់ថាកំពុងរង់ចាំ' ដើម្បីកត់ត្រាការទូទាត់ឥឡូវនេះ។",
        SelectCustomerAndItemFirst: "សូមជ្រើសរើសអតិថិជន និងយ៉ាងហោចណាស់ធាតុមួយជាមុនសិន",
        SelectSupplierAndItemFirst: "សូមជ្រើសរើសអ្នកផ្គត់ផ្គង់ និងយ៉ាងហោចណាស់ធាតុមួយជាមុនសិន",
        SelectCustomerProductFirst: "ជ្រើសរើសអតិថិជន និងផលិតផលជាមុនសិន",
        SelectSupplierProductFirst: "ជ្រើសរើសអ្នកផ្គត់ផ្គង់ និងផលិតផលជាមុនសិន",
        Receivables: "ថវិកាត្រូវទទួល",
        Payables: "ថវិកាត្រូវបង់",
        OrderType: "ប្រភេទការបញ្ជាទិញ",
        SelectOrderType: "ជ្រើសរើសប្រភេទការបញ្ជាទិញ",
        OrderTypePrepaid: "បង់ប្រាក់មុន",
        OrderTypeCOD: "បង់ប្រាក់ពេលទទួលទំនិញ",
        OrderTypePayLater: "បង់ប្រាក់ពេលក្រោយ",
        OrderTypePartialPayment: "បង់ប្រាក់ខ្លះ",
        OrderTypeSubscription: "ការជាវ",
        purchase: "ការទិញ",
        sales: "ការលក់",
        viewAvailabilty: 'មើលពេលវេលាដែលអាចប្រើបាន',
        NotReceived: "មិនទាន់ទទួល",
        NotShipped: "មិនទាន់ដឹកជញ្ជូន",
        PartiallyReceived: "ទទួលបានមួយផ្នែក",
        PartiallyShipped: "ដឹកជញ្ជូនមួយផ្នែក",
        NewSalesOrder: "ការបញ្ជាទិញលក់ថ្មី",
        NewPurchaseOrder: "ការបញ្ជាទិញទិញថ្មី",
        Createandmanageyour: "បង្កើតនិងគ្រប់គ្រង",
        orders: "ការបញ្ជាទិញរបស់អ្នក",
        UnitPrice: "តម្លៃឯកតា",
        Stockoutitemsimmediatelyaftersaving: "ដកស្តុកទំនិញភ្លាមៗបន្ទាប់ពីរក្សាទុក",
        Stockinitemsimmediatelyaftersavingthisorder: "បញ្ចូលស្តុកទំនិញភ្លាមៗបន្ទាប់ពីរក្សាទុក",
        Received: "បានទទួល",
        Shipped: "បានដឹកជញ្ជូន",
        CreateSalesOrder: "បង្កើតការបញ្ជាទិញលក់",
        CreatePurchaseOrder: "បង្កើតការបញ្ជាទិញ",
        OrderDate: "កាលបរិច្ឆេទបញ្ជាទិញ",
        ReceivedDate: "កាលបរិច្ឆេទទទួល",
        Order: "ការបញ្ជាទិញ",
        OrderSummary: "សង្ខេបការបញ្ជាទិញ",
        Subtotal: "សរុបរង",
        Removeitem: "លុបទំនិញ",
        AddItem: "បន្ថែមទំនិញ",
        MemoAttachments: "អនុស្សរណៈ និងឯកសារភ្ជាប់",
        ManageAttachments: "គ្រប់គ្រងឯកសារភ្ជាប់",
    },
    CategoryNewL: {
        TotalCategories: "ចំនួនប្រភេទសរុប",
        lastaddedcategory: "ប្រភេទដែលបានបន្ថែមចុងក្រោយ",
        acrossalltypes: "នៅគ្រប់ប្រភេទទាំងអស់",
        MostRecent: "ថ្មីបំផុត",
        YesD: "បាទ/ចាស លុប",
        AllAssociated: "ផលិតផលទាំងអស់ដែលពាក់ព័ន្ធអាចនឹងត្រូវបានប៉ះពាល់"
    },
    OverDas: {
        movestockbetweenlocations: "ផ្លាស់ទីស្តុក",
        no_activity_yet: "មិនទាន់មានសកម្មភាពនៅឡើយទេ",
        no_activity_sub: "ការលក់ ការទិញ ចលនាស្តុក និងការត្រឡប់មកវិញនឹងបង្ហាញនៅទីនេះជាពេលវេលាជាក់ស្តែង។",
        make_first_sale: "ធ្វើការលក់ដំបូង",
        add_stock: "បន្ថែមស្តុក",
        all_stock_healthy: "កម្រិតស្តុកទាំងអស់មានសុខភាពល្អ",
        all_stock_healthy_sub: "គ្មានទំនិញណាមួយជិតអស់ទេ។ កំណត់កម្រិតអប្បបរមានៅលើផលិតផលដើម្បីទទួលបានការជូនដំណឹងនៅទីនេះ។",
        set_stock_thresholds: "កំណត់កម្រិតស្តុក",
        no_warehouses_setup: "មិនទាន់មានឃ្លាំងត្រូវបានរៀបចំទេ",
        no_warehouses_setup_sub: "បន្ថែមឃ្លាំងដើម្បីចាប់ផ្តើមតាមដានកន្លែងដែលស្តុករបស់អ្នកត្រូវបានរក្សាទុក និងគ្រប់គ្រងទីតាំង។",
        add_first_warehouse: "បន្ថែមឃ្លាំងដំបូង",
        Customer: "អតិថិជន",
        PurchasevsSales: "ការទិញ និងការលក់",
        Financialperformancechart: "តារាងប្រតិបត្តិការហិរញ្ញវត្ថុ",
        QuickActions: "សកម្មភាពរហ័ស",
        Frequentlyused: "ប្រើញឹកញាប់",
        Addinventory: "បន្ថែមស្តុក",
        Dispatchitems: "បញ្ជូនទំនិញ",
        Addorder: "បន្ថែមការបញ្ជាទិញ",
        Newitem: "ទំនិញថ្មី",
        Inventoryaccess: "ការចូលប្រើស្តុក",
        Itemsneedingreorder: "ទំនិញដែលត្រូវការបញ្ជាទិញឡើងវិញ",
        Latesttransactions: "ប្រតិបត្តិការថ្មីៗ",
        Operationalsummary: "សង្ខេបប្រតិបត្តិការ",
        ViewAll: "មើលទាំងអស់",
        Manage: "គ្រប់គ្រង",
        RecentActivity: "សកម្មភាពថ្មីៗ",
        LowStockAlerts: "ការជូនដំណឹងស្តុកទាប",
        Primary: "ចម្បង",
        TotalWarehouses: "ឃ្លាំងសរុប"
    },
    SerialLocal: {
        ShowOrHideFields: "បង្ហាញ ឬលាក់វាល",
        ShowOrHideFieldsDesc: "ប៉ះធាតុណាមួយខាងក្រោមដើម្បីបញ្ចូល ឬលុបវាចេញពីវិក្កយបត្រដែលបានបោះពុម្ព។ ការផ្លាស់ប្តូរត្រូវបានអនុវត្តភ្លាមៗ។",
        Manufacturesettings: "ការកំណត់ការផលិត",
        Showbuyingprice: "តម្លៃទិញ / ថ្លៃដើមផលិតផល",
        Showadditionalcost: "ថ្លៃបន្ថែម",
        Costbreakdown: "ការវិភាគថ្លៃដើម",
        Unitcost: "ថ្លៃដើមក្នុងមួយឯកតា",
        Rawmaterialstotal: "វត្ថុធាតុដើមសរុប",
        Confirmentry: "បញ្ជាក់ការបញ្ចូល",
        SaveSerials: "រក្សាទុកលេខសេរៀល",
        SerialNumber: "លេខសេរៀល",
        selected: "បានជ្រើសរើស",
        added: "បានបន្ថែម",
        Serialnumbers: "លេខសេរៀល",
        ResetAll: "កំណត់ឡើងវិញទាំងអស់",
        Wecouldnfindthis: "យើងមិនអាចរកឃើញលេខសេរៀលដែលមានសម្រាប់ផលិតផលនេះទេ។",
        Nounitsfound: "រកមិនឃើញឯកតា",
        Searchingserialnumbers: "កំពុងស្វែងរកលេខសេរៀល...",
        Scanorenterstock: "ស្កេន ឬបញ្ចូលលេខសេរៀលសម្រាប់ស្តុកថ្មី",
        Whataserialnumber: "លេខសេរៀលគឺជាអ្វី?",
        Auniqueidentifieryourinventorylifecycle: "អត្តសញ្ញាណប្ដូរតែមួយក្នុងមួយឯកតា — អនុញ្ញាតឱ្យអ្នកតាមដានរាល់ធាតុនីមួយៗក្នុងវដ្តជីវិតស្តុករបស់អ្នក។",
        Trackedstockout: "ការចេញស្តុកដែលបានតាមដាន",
        Chooseexactlyselected: "ជ្រើសរើសយ៉ាងពិតប្រាកដថាលេខស៊េរីណាខ្លះកំពុងចេញ។ មានតែលេខស៊េរីដែលបានដាក់ស្តុកសម្រាប់ផលិតផលនេះប៉ុណ្ណោះដែលត្រូវបានបង្ហាញ — បរិមាណនឹងចាក់សោនៅពេលអ្នកបានជ្រើសរើស ",
        SelectSerialstoout: " - ជ្រើសរើសលេខសេរៀលដើម្បីចេញ",
        Thisinvoicegeneratedusingwwwsimplstockco: "វិក្កយបត្រនេះត្រូវបានបង្កើតដោយប្រើ www.simplstock.co",
        AuthorizedSignature: "ហត្ថលេខាអនុញ្ញាត",
        Invoicesettings: "ការកំណត់វិក្កយបត្រ",
        Notransactionsfound: "រកមិនឃើញប្រតិបត្តិការទេ",
        Draw: "គូរ",
        Taptoselectordeselectitems: "ប៉ះដើម្បីជ្រើសរើស ឬមិនជ្រើសរើសធាតុ",
        Thissignaturewillbeadded: "ហត្ថលេខានេះនឹងត្រូវបានបន្ថែមនៅផ្នែកខាងក្រោមនៃវិក្កយបត្រដែលបោះពុម្ព។",
        SignatureOptions: "ជម្រើសហត្ថលេខា",
        Upload: "ផ្ទុកឡើង",
        DrawSignature: "គូរហត្ថលេខា",
        UploadSignature: "ផ្ទុកហត្ថលេខាឡើង",
        Clear: "លុប",
        ShowStaffName: "ឈ្មោះបុគ្គលិក",
        ShowSKU: "SKU",
        ShowBusinessName: "ឈ្មោះអាជីវកម្ម",
        ShowProductName: "ឈ្មោះផលិតផល",
        ShowBusinessPhoneNumber: "លេខទូរស័ព្ទ",
        ShowBusinessEmail: "អ៊ីមែល",
        ShowBusinessAddress: "អាសយដ្ឋាន",
        ShowProductImage: "រូបភាពផលិតផល",
        ShowPaymentDetails: "ព័ត៌មានលម្អិតអំពីការទូទាត់",
        ShowCategory: "ប្រភេទ",
        ShowVariant: "វ៉ារ្យ៉ង់",
        ShowWarehouse: "ឃ្លាំង",
        ShowAttributes: "គុណលក្ខណៈ",
        ShowQuantity: "បរិមាណ",
        ShowDiscount: "បញ្ចុះតម្លៃ",
        ShowTax: "ពន្ធ",
        ShowPrice: "តម្លៃ",
        ShowTotalPrice: "តម្លៃសរុបផលិតផល",
        ShowExpenses: "ចំណាយ",
        ShowSignature: "ហត្ថលេខា",
        ShowNote: "កំណត់ត្រា",
        ShowSerialNumber: "លេខសេរៀល",
        Invoicesettingsapplied: "ការកំណត់វិក្កយបត្រត្រូវបានអនុវត្ត។ ពិនិត្យវិក្កយបត្រសម្រាប់ការផ្លាស់ប្តូរ",
        EnterSerialNumber: "បញ្ចូលលេខសេរៀល",
        showAttachment: "ឯកសារភ្ជាប់"
    },
    FewLocal: {
        SelectBin: "ជ្រើសរើសប៊ីន",
        Live: "ផ្ទាល់",
        Monitorinventorystocklevels: "តាមដានស្តុក ចលនា និងកម្រិតស្តុក",
        StockControlCentre: "មជ្ឈមណ្ឌលគ្រប់គ្រងស្តុក",
        Nochartdataavailable: "គ្មានទិន្នន័យតារាង",
        Disabled: "បិទ",
        Enabled: "បើក"
    },
    Bin: {
        Bin: "ប៊ីន",
        Add: "បន្ថែម",
        NoBinsAddedYet: "មិនទាន់មានប៊ីនត្រូវបានបន្ថែមនៅឡើយទេ",
        BinLocationsHelp: "ទីតាំងប៊ីនជួយអ្នកតាមដានស្តុកតាមទីតាំងច្បាស់លាស់នៅខាងក្នុងឃ្លាំងនេះ — មិនចាំបាច់ស្វែងរកទៀតទេ។",
        NameThemByPosition: "ដាក់ឈ្មោះតាមទីតាំង៖",
        AddBinLocation: "បន្ថែមទីតាំងប៊ីន",
        BinLocations: "ទីតាំងប៊ីន",
        BinNameRequired: "ត្រូវការឈ្មោះប៊ីន",
        EditBin: "កែសម្រួលប៊ីន",
        AddBin: "បន្ថែមប៊ីន",
        EnterBinName: "ឈ្មោះប៊ីន",
        EnterBinNamePlaceholder: "បញ្ចូលឈ្មោះប៊ីន",
        BinStatus: "ស្ថានភាពប៊ីន",
        BinNotes: "កំណត់ត្រា",
        EnterBinNotesPlaceholder: "បន្ថែមកំណត់ត្រា...",
        ViewInventory: "មើលស្តុក",
        Inventory: "ស្តុក",
        TrymatchingadifferentSKUname: "ព្យាយាមផ្គូផ្គង SKU ឬឈ្មោះផ្សេង।",
        Thisbinlocationcurrentlyempty: "ទីតាំងប៊ីននេះបច្ចុប្បន្នទទេ។",
        Loadingbins: "កំពុងផ្ទុកប៊ីន...",
        bins: "ប៊ីន",
        ManageBin: "គ្រប់គ្រងប៊ីន",
        Print: "បោះពុម្ព",
        SBin: "ប៊ីនប្រភព",
        DBin: "ប៊ីនគោលដៅ"
    },
    WarehouseExcel: {
        title: "ផ្ទុកឃ្លាំង & ទីតាំងប៊ីន",
        description: "អនុវត្តតាមជំហានខាងក្រោមដើម្បីបង្កើតឃ្លាំងជាច្រើនរួមទាំងទីតាំងប៊ីនដោយប្រើឯកសារ Excel។",
        bulkUploadGuide: "មគ្គុទ្ទេសក៍ផ្ទុកទិន្នន័យភ្លាមៗ",
        step1: "ជំហានទី ១",
        downloadTemplate: "ទាញយកគំរូ Excel",
        downloadTemplateDesc: "ទាញយកគំរូផ្លូវការដែលមានក្បាលជួរឈរទាំងអស់។ កុំប្តូរឈ្មោះ ឬលុបជួរឈរ។",
        downloadTemplateBtn: "ទាញយកគំរូ",
        step2: "ជំហានទី ២",
        fillExcelFile: "បំពេញឯកសារ Excel",
        fillExcelDesc: "រាល់ជួរតំណាងឱ្យឃ្លាំងមួយ។ បំពេញគ្រប់ជួរឈរ — សម្រាប់ទីតាំងប៊ីន សរសេរឈ្មោះប៊ីនទាំងអស់ដោយបំបែកដោយក្បៀសក្នុងជួរ <code>Bin Names</code>।",
        step3: "ជំហានទី ៣",
        thingsToKeepInMind: "របស់ដែលត្រូវចងចាំ",
        rulesDesc: "មុនពេលផ្ទុក សូមធ្វើឱ្យប្រាកដថាឯកសាររបស់អ្នកគោរពតាមច្បាប់ទាំងនេះ।",
        step4: "ជំហានទី ៤",
        uploadYourFile: "ផ្ទុកឯកសាររបស់អ្នក",
        uploadDesc: "ពេលបំពេញរួច ផ្ទុកឯកសារខាងក្រោម។ ប្រព័ន្ធនឹងបង្កើតឃ្លាំងនិងទីតាំងប៊ីនទាំងអស់ដោយស្វ័យប្រវត្តិ।",
        rules: ["មួយជួរក្នុងមួយឃ្លាំង", "ឈ្មោះប៊ីនបំបែកដោយក្បៀសក្នុងក្រឡាមួយ", "កុំប្តូរឈ្មោះក្បាលជួរ", "ឈ្មោះប៊ីនស្ទួនក្នុងឃ្លាំងត្រូវបានរំលង", "លេខទូរស័ព្ទមានកូដប្រទេស", "ទទួលតែឯកសារ .xlsx ឬ .xls"],
        dropFileHere: "ទម្លាក់ឯកសារ Excel នៅទីនេះ",
        supports: "គាំទ្រ .xlsx និង .xls — អតិបរមា 10 MB",
        chooseFileUpload: "ជ្រើសឯកសារ & ផ្ទុក",
        parsing: "កំពុងវិភាគឯកសារ...",
        invalidFileType: "ប្រភេទឯកសារមិនត្រឹមត្រូវ។ សូមផ្ទុកឯកសារ Excel।",
        noData: "រកមិនឃើញទិន្នន័យក្នុង Excel",
        failedToRead: "មិនអាចអានឯកសារ Excel",
        unableToRead: "មិនអាចអានឯកសារ।",
        reviewTitle: "ពិនិត្យទិន្នន័យឃ្លាំង",
        reviewSubtitle: "ការពិនិត្យចុងក្រោយមុននឹងនាំចូលទៅក្នុងអាជីវកម្មរបស់អ្នក।",
        changeFile: "ផ្លាស់ប្តូរឯកសារ",
        rowsFound: "ជួររកឃើញ",
        cancel: "បោះបង់",
        finalizeImport: "បញ្ចប់ & នាំចូល",
        importing: "កំពុងនាំចូល...",
        success: "ជោគជ័យ",
        allWarehouseUploadedSuccess: "ឃ្លាំងទាំងអស់ត្រូវបានផ្ទុកដោយជោគជ័យ",
        failed: "បរាជ័យ",
        bulkUploadFailed: "ការផ្ទុកភ្លាមៗបរាជ័យ",
        error: "កំហុស",
        binNamesNote: "នៅក្នុងជួរ <strong>Bin Names</strong> សូមបញ្ចូលទីតាំងប៊ីនទាំងអស់ក្នុងក្រឡាតែមួយ បំបែកដោយក្បៀស — ឧ. A1, A2, B1, RACK-01।",
        headers: { warehouseName: "ឈ្មោះឃ្លាំង", email: "អ៊ីមែល", phoneNumber: "លេខទូរស័ព្ទ", location: "ទីតាំង", binNames: "ឈ្មោះប៊ីន" }
    },
    VariantTemplate: {
        VariantTemplates: "គំរូវ៉ារ្យ៉ង់",
        Managereusablevariantpatterns: "គ្រប់គ្រងគំរូវ៉ារ្យ៉ង់ដែលអាចប្រើបានឡើងវិញ",
        BinTransferHistory: "ប្រវត្តិផ្ទេរប៊ីន",
        Trackmovementsacrossbins: "តាមដានចលនារវាងប៊ីន",
        SerialNumberHistory: "ប្រវត្តិលេខសេរៀល",
        Trackproductserialnumberactivity: "តាមដានសកម្មភាពលេខសេរៀលផលិតផល",
        Period: "រយៈពេល",
        Nohistoryfound: "រកមិនឃើញប្រវត្តិ",
        Searchserialnumbers: "ស្វែងរកលេខសេរៀល...",
        SerialNumbersHistory: "ប្រវត្តិលេខសេរៀល",
        Serialnumberhistoryglance: "ប្រវត្តិលេខសេរៀលមួយមើល.",
        Noserialnumbersfound: "រកមិនឃើញលេខសេរៀល",
        Noactivityhistoryfound: "រកមិនឃើញប្រវត្តិសកម្មភាព",
        Statussetto: "កំណត់ស្ថានភាពជា",
        Timeline: "បន្ទាត់ពេលវេលា",
        Managereusableproductvariantpatterns: "គ្រប់គ្រងគំរូវ៉ារ្យ៉ង់ផលិតផលដែលអាចប្រើបានឡើងវិញ។",
        DeleteTemplate: "លុបគំរូ",
        Areyousureyouwanttemplate: "តើអ្នកពិតជាចង់លុបគំរូនេះមែនទេ?",
        CreateNewTemplate: "បង្កើតគំរូថ្មី",
        CreateTemplate: "បង្កើតគំរូ",
        EditTemplate: "កែសម្រួលគំរូ",
        UnlimitedTemplates: "គំរូគ្មានដែនកំណត់",
        CreateAsManyTemplates: "បង្កើតគំរូឱ្យបានច្រើនតាមត្រូវការ — សំលៀកបំពាក់ ស្បែកជើង អេឡិចត្រូនិក និងផ្សេងៗទៀត។",
        PickWhileAddingProduct: "ជ្រើសរើសពេលបន្ថែមផលិតផល",
        OpenTemplateLibrary: "បើកបណ្ណាល័យគំរូរបស់អ្នក និងជ្រើសរើសឈ្មោះវ៉ារ្យ៉ង់ក្នុងរយៈពេលពីរបីវិនាទី។",
        MixFromMultipleTemplates: "លាយពីគំរូច្រើន",
        SelectFromMultipleTemplates: "ជ្រើសរើសឈ្មោះវ៉ារ្យ៉ង់ពីគំរូច្រើនសម្រាប់ផលិតផលតែមួយ — អាចបត់បែនបានពេញលេញ។",
        EditAnytime: "កែសម្រួលគ្រប់ពេល",
        RenameTemplatesAnytime: "ប្តូរឈ្មោះគំរូ បន្ថែម ឬលុបឈ្មោះវ៉ារ្យ៉ង់នៅពេលកាតាឡូករបស់អ្នកផ្លាស់ប្តូរ។",
        StayConsistent: "រក្សាភាពស៊ីសង្វាក់",
        SameVariantNamesAcrossAll: "ឈ្មោះវ៉ារ្យ៉ង់ដូចគ្នានៅគ្រប់ផលិតផលទាំងអស់។ គ្មានកំហុសអក្សរ គ្មានស្ទួន គ្មានទាយទុក។",
        BuildOnceUseEverywhere: "បង្កើតម្តង, ប្រើគ្រប់កន្លែង",
        StopReEnteringVariantNames: "ឈប់វាយឈ្មោះវ៉ារ្យ៉ង់ដដែលៗសម្រាប់រាល់ផលិតផល। បង្កើតគំរូមួយ ផ្ដល់ឈ្មោះវ៉ារ្យ៉ង់ ហើយប្រើវាភ្លាមៗ។",
        Updateexistingvariantcombinations: "ធ្វើបច្ចុប្បន្នភាពការរួមបញ្ចូលវ៉ារ្យ៉ង់ដែលមានស្រាប់",
        Definenewvariantcombinations: "កំណត់ការរួមបញ្ចូលវ៉ារ្យ៉ង់ថ្មី",
        TemplateName: "ឈ្មោះគំរូ",
        AddVariantOptions: "បន្ថែមជម្រើសវ៉ារ្យ៉ង់",
        SmallMedium: "ឧ. Small, Medium...",
        VariantsList: "បញ្ជីវ៉ារ្យ៉ង់",
        Nooptionsaddedyet: "មិនទាន់មានជម្រើសណាមួយត្រូវបានបន្ថែម",
        SaveTemplate: "រក្សាទុកគំរូ",
        egSizesColorsetc: "ឧ. ទំហំអាវ, ពណ៌, ។ល។",
        Pleaseentertemplatename: "សូមបញ្ចូលឈ្មោះគំរូ",
        Pleaseaddatleastonevariantoption: "សូមបន្ថែមយ៉ាងហោចណាស់ជម្រើសវ៉ារ្យ៉ង់មួយ",
        Templateupdatedsuccessfully: "គំរូត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ",
        Templatecreatedsuccessfully: "គំរូត្រូវបានបង្កើតដោយជោគជ័យ",
        Failedtosavetemplate: "មិនអាចរក្សាទុកគំរូ",
        Transfer: "ផ្ទេរ",
        Editassignment: "កែសម្រួលការផ្ដល់",
        Updateproductdetailsinbin: "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានផលិតផលក្នុងប៊ីន",
        Editinginbin: "កំពុងកែសម្រួលក្នុងប៊ីន",
        ConfirmUpdate: "បញ្ជាក់ការធ្វើបច្ចុប្បន្នភាព",
        ConfirmAssign: "បញ្ជាក់ការផ្ដល់",
        Assignanotherproduct: "ផ្ដល់ផលិតផលមួយផ្សេងទៀត",
        TransferBin: "ផ្ទេរប៊ីន",
        SourceBin: "ប៊ីនប្រភព",
        DestinationBin: "ប៊ីនគោលដៅ",
        SelectSourceBin: "ជ្រើសរើសប៊ីនប្រភព",
        SelectDestinationBin: "ជ្រើសរើសប៊ីនគោលដៅ",
        Unit: "ឯកតា",
        ManageVariant: "គ្រប់គ្រងវ៉ារ្យ៉ង់",
        CreateSKUvariationsyourproduct: "បង្កើត SKU វ៉ារ្យ៉ង់សម្រាប់ផលិតផលរបស់អ្នក",
        Assigningvariationsto: "កំពុងផ្ដល់វ៉ារ្យ៉ង់ទៅ",
        Novariantsaddedyet: "មិនទាន់មានវ៉ារ្យ៉ង់ត្រូវបានបន្ថែម",
        AddedVariants: "វ៉ារ្យ៉ង់ដែលបានបន្ថែម",
        AddVariantsfromTemplate: "បន្ថែមវ៉ារ្យ៉ង់ពីគំរូ",
        Pickatemplateandselectvariantnames: "ជ្រើសរើសគំរូ និងជ្រើសរើសឈ្មោះវ៉ារ្យ៉ង់",
        ChooseaTemplate: "ជ្រើសរើសគំរូ",
        Selectvariantnamestoadd: "ជ្រើសរើសឈ្មោះវ៉ារ្យ៉ង់ដើម្បីបន្ថែម",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "ជ្រើសរើសគំរូដើម្បីជ្រើសរើសឈ្មោះវ៉ារ្យ៉ង់। អ្នកអាចបន្ថែមពីច្រើនគំរូ।",
        Loadingtemplates: "កំពុងផ្ទុកគំរូ...",
        Backtotemplates: "ត្រឡប់ទៅគំរូ",
        Selectallindividualadd: "ជ្រើសរើសទាំងអស់ ឬឈ្មោះវ៉ារ្យ៉ង់នីមួយៗដើម្បីបន្ថែម।",
        VariantNames: "ឈ្មោះវ៉ារ្យ៉ង់",
        MediaDescription: "មេឌា & ការពិពណ៌នា",
        Addattachmentsandproductnotes: "បន្ថែមឯកសារភ្ជាប់និងកំណត់ត្រាផលិតផល",
        ProductMedia: "មេឌាផលិតផល"
    },
    AddProductGuide: {
        title: "បន្ថែមបរិមាណដំបូងបន្ទាប់ពីរក្សាទុក",
        description: "ផលិតផលមិនមានវាលបរិមាណនៅទីនេះទេ។ បន្ទាប់ពីរក្សាទុក ប្រើ 'Stock In' ដើម្បីកត់ត្រាស្តុកដំបូងរបស់អ្នក — ជាមួយនឹងการគ្រប់គ្រងពេញលេញលើទីតាំងនិងការតាមដាន។",
        steps: {
            quantity: { title: "បរិមាណ", sub: "កំណត់ចំនួនស្តុកដំបូង" },
            binLocation: { title: "ទីតាំងប៊ីន", sub: "ច្រករបៀង ធ្នើរ ធ្នើរ — ឧ. A-01-03" },
            serialNumbers: { title: "លេខសេរៀល", sub: "តាមដានរាល់យូនីតនីមួយៗ" },
            warehouse: { title: "ឃ្លាំង", sub: "កន្លែងណាដែលវាត្រូវបានរក្សាទុក" },
            batchExpiry: { title: "បាច់ / ផុតកំណត់", sub: "ដាក់ជាក្រុមស្តុកតាមលេខបាច់" }
        },
        actions: { close: "បិទ" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "រកមិនឃើញការបញ្ជាទિញផ្ទេរ",
        Itemshistory: "ធាតុដែលអ្នកផ្ទេររវាងឃ្លាំងនឹងបង្ហាញនៅទីនេះសម្រាប់ការតាមដាននិងប្រវត្តិ។",
        CreateTransfer: "បង្កើតការផ្ទេរ"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "ប៉ះលើផលិតផលដើម្បីផលិត",
        Selectproductfrombelow: "ជ្រើសរើសផលិតផលពីបញ្ជីខាងក្រោម",
        SetupANewProduct: "រៀបចំផលិតផលថ្មី",
        DefineAProductAdditsrawmaterial: "កំណត់ផលិតផល និងបន្ថែមវត្ថុធាតុដើម",
        ManufacturingSetup: "ការរៀបចំការផលិត",
        Pickproducttodefineitsproductiondetails: "ជ្រើសរើសផលិតផលដើម្បីកំណត់ព័ត៌មានលម្អិតនៃការផលិត",
        ConfigureManufacturing: "កំណត់ការផលិត",
        SelectRawMaterial: "ជ្រើសរើសវត្ថុធាតុដើម",
        NoRawMaterials: "មិនមានវត្ថុធាតុដើម",
        Definecomponentsneededtoproduct: "កំណត់សមាសធាតុដែលត្រូវការដើម្បីផលិតផលិតផលនេះ។",
        NoAdditionalCosts: "មិនមានការចំណាយបន្ថែម",
        Addlaboroverheadlogisticalcharges: "បន្ថែមការចំណាយលើកម្លាំងពលកម្ម ការចំណាយទូទៅ ឬការដឹកជញ្ជូន។",
        AddAdditionalCost: "បន្ថែមការចំណាយបន្ថែម",
        AddCost: "បន្ថែមការចំណាយ",
        TotalPrice: "តម្លៃសរុប",
        SelectCharges: "ជ្រើសរើសការចំណាយ",
        EnterEstimatedCost: "បញ្ចូលការចំណាយប៉ាន់ស្មាន",
        QtyRequried: "បរិមាណដែលត្រូវការ",
        Manufacturing: "ការផលិត",
        Outputfinishedgoodsdestination: "គោលដៅផលិតផលសម្រេច",
        Manufacturingquantity: "បរិមាណផលិត",
        Storefinishedgoodsat: "រក្សាទុកផលិតផលសម្រេចនៅ",
        Rawmaterials: "វត្ថុធាតុដើម",
        StockSelection: "ការជ្រើសរើសស្តុក",
        AdditionalCosts: "ការចំណាយបន្ថែម",
        Quantityconsume: "បរិមាណប្រើប្រាស់",
        Totalmanufacturingcost: "ការចំណាយផលិតសរុប",
        Sumofrawmaterialcosts: "ផលបូកនៃតម្លៃវត្ថុធាតុដើមទាំងអស់",
        CustomManufacturingCharge: "ការចំណាយផលិតកម្មផ្ទាល់ខ្លួន",
        Addextralikelaboroverheadrepairs: "បន្ថែមការចំណាយបន្ថែមដូចជាកម្លាំងពលកម្ម ចំណាយទូទៅ ឬការជួសជុល។",
        CalculatedTotal: "សរុបដែលបានគណនា",
        AddRawMaterial: "បន្ថែមវត្ថុធាតុដើម",
        ConfigureRawMaterial: "កំណត់វត្ថុធាតុដើម",
        Thisoutputunit: "នេះគឺជាបរិមាណមូលដ្ឋានដែលត្រូវការក្នុងមួយឯកតាផលិតផល។",
        ChangeProduct: "ប្តូរផលិតផល",
        AddtoList: "បន្ថែមទៅក្នុងបញ្ជី",
        ManufacturedSuccessfully: "ផលិតបានជោគជ័យ",
        Manufacture: "ការផលិត",
        EditDeleteHistory: "ប្រវត្តិ កែសម្រួល/លុប",
        ManageOrder: "គ្រប់គ្រងការបញ្ជាទិញ",
        ManageBatch: "គ្រប់គ្រងបាច់",
        Paymentnotavailablehere: "ការទូទាត់មិនអាចធ្វើបាននៅទីនេះ",
        Thisrecordisanorderorderitself: "កំណត់ត្រានេះមកពីការបញ្ជាទិញ។ ការទូទាត់អាចកត់ត្រាបានតែពីការបញ្ជាទិញប៉ុណ្ណោះ。",
        Torecorpaymenttheorderthethere: "ដើម្បីកត់ត្រាការទូទាត់ សូមទៅកាន់ការបញ្ជាទិញដែលភ្ជាប់ ហើយប្រើជម្រើស <b>កត់ត្រាការទូទាត់</b> នៅទីនោះ។",
        GotoOrder: "ទៅកាន់ការបញ្ជាទិញ"
    },
    CustomerExcel: {
        title: "បញ្ចូលទិន្នន័យអតិថិជន",
        description: "អនុវត្តតាមជំហានខាងក្រោមដើម្បីបង្កើតអតិថិជនក្នុងចំនួនច្រើនដោយប្រើឯកសារ Excel ។",
        bulkUploadGuide: "ការណែនាំអំពីការបញ្ចូលទិន្នន័យច្រើន",
        step1: "ជំហានទី ១",
        downloadTemplate: "ទាញយកគំរូ Excel",
        downloadTemplateDesc: "ទទួលបានគំរូផ្លូវការជាមួយចំណងជើងជួរឈរដែលបានកំណត់រចនាសម្ព័ន្ធជាស្រេច។",
        downloadTemplateBtn: "ទាញយកគំរូ",
        step2: "ជំហានទី ២",
        fillExcelFile: "បំពេញក្នុងឯកសារ Excel",
        fillExcelDesc: "ជួរនីមួយៗតំណាងឱ្យអតិថិជនម្នាក់។ បំពេញជួរឈរទាំងអស់តាមតម្រូវការ។",
        step3: "ជំហានទី ៣",
        thingsToKeepInMind: "អ្វីដែលត្រូវចងចាំ",
        rulesDesc: "មុនពេលបញ្ចូល សូមប្រាកដថាឯកសាររបស់អ្នកអនុវត្តតាមច្បាប់ទាំងនេះដើម្បីជៀសវាងកំហុស។",
        step4: "ជំហានទី ៤",
        uploadYourFile: "បញ្ចូលឯកសាររបស់អ្នក",
        uploadDesc: "នៅពេលបំពេញរួចរាល់ សូមបញ្ចូលឯកសារខាងក្រោម។ ប្រព័ន្ធនឹងបង្កើតអតិថិជនទាំងអស់ដោយស្វ័យប្រវត្តិ។",
        rules: [
            "ជួរដេកមួយសម្រាប់តែអតិថិជនម្នាក់ប៉ុណ្ោះ",
            "កុំប្តូរឈ្មោះចំណងជើងជួរឈរ",
            "លេខទំនាក់ទំនងជាមួយលេខកូដប្រទេស",
            "ទទួលយកតែឯកសារ .xlsx ឬ .xls ប៉ុណ្ណោះ"
        ],
        dropFileHere: "ទម្លាក់ឯកសារ Excel របស់អ្នកនៅទីនេះ",
        supports: "គាំទ្រ .xlsx និង .xls — អតិបរមា 10 MB",
        chooseFileUpload: "ជ្រើសរើសឯកសារ និងបញ្ចូល",
        parsing: "កំពុងវិភាគឯកសារ...",
        invalidFileType: "ប្រភេទឯកសារមិនត្រឹមត្រូវ។ សូមបញ្ចូលឯកសារ Excel ។",
        noData: "រកមិនឃើញទិន្នន័យក្នុង Excel ទេ",
        failedToRead: "ការអានឯកសារ Excel បរាជ័យ",
        unableToRead: "មិនអាចអានឯកសារបានទេ។",
        reviewTitle: "ពិនិត្យមើលទិន្នន័យអតិថិជន",
        reviewSubtitle: "ការត្រួតពិនិត្យចុងក្រោយមុនពេលបញ្ចូលទៅក្នុងអាជីវកម្មរបស់អ្នក។",
        changeFile: "ប្តូរឯកសារ",
        rowsFound: "ជួរដេកត្រូវបានរកឃើញក្នុងឯកសារ",
        cancel: "បោះបង់",
        finalizeImport: "បញ្ចប់ និងបញ្ចូល",
        importing: "កំពុងបញ្ចូល...",
        success: "ជោគជ័យ",
        allCustomerUploadedSuccess: "អតិថិជនទាំងអស់ត្រូវបានបញ្ចូលដោយជោគជ័យ",
        failed: "បរាជ័យ",
        bulkUploadFailed: "ការបញ្ចូលទិន្នន័យច្រើនបានបរាជ័យ",
        error: "កំហុស",
        headers: {
            customerName: "ឈ្មោះអតិថិជន",
            phoneNumber: "ទំនាក់ទំនង",
            address: "អាសយដ្ឋាន",
            note: "កំណត់ចំណាំ"
        }
    },
    SupplierExcel: {
        title: "បញ្ចូលទិន្នន័យអ្នកផ្គត់ផ្គង់",
        description: "អនុវត្តតាមជំហានខាងក្រោមដើម្បីបង្កើតអ្នកផ្គត់ផ្គង់ក្នុងចំនួនច្រើនដោយប្រើឯកសារ Excel ។",
        bulkUploadGuide: "ការណែនាំអំពីការបញ្ចូលទិន្នន័យច្រើន",
        step1: "ជំហានទី ១",
        downloadTemplate: "ទាញយកគំរូ Excel",
        downloadTemplateDesc: "ទទួលបានគំរូផ្លូវការជាមួយចំណងជើងជួរឈរដែលបានកំណត់រចនាសម្ព័ន្ធជាស្រេច។",
        downloadTemplateBtn: "ទាញយកគំរូ",
        step2: "ជំហានទី ២",
        fillExcelFile: "បំពេញក្នុងឯកសារ Excel",
        fillExcelDesc: "ជួរនីមួយៗតំណាងឱ្យអ្នកផ្គត់ផ្គង់ម្នាក់។ បំពេញជួរឈរទាំងអស់តាមតម្រូវការ។",
        step3: "ជំហានទី ៣",
        thingsToKeepInMind: "អ្វីដែលត្រូវចងចាំ",
        rulesDesc: "មុនពេលបញ្ចូល សូមប្រាកដថាឯកសាររបស់អ្នកអនុវត្តតាមច្បាប់ទាំងនេះដើម្បីជៀសវាងកំហុស។",
        step4: "ជំហានទី ៤",
        uploadYourFile: "បញ្ចូលឯកសាររបស់អ្នក",
        uploadDesc: "នៅពេលបំពេញរួចរាល់ សូមបញ្ចូលឯកសារខាងក្រោម។ ប្រព័ន្ធនឹងបង្កើតអ្នកផ្គត់ផ្គង់ទាំងអស់ដោយស្វ័យប្រវត្តិ។",
        rules: [
            "ជួរដេកមួយសម្រាប់តែអ្នកផ្គត់ផ្គង់ម្នាក់ប៉ុណ្ោះ",
            "កុំប្តូរឈ្មោះចំណងជើងជួរឈរ",
            "លេខទំនាក់ទំនងជាមួយលេខកូដប្រទេស",
            "ទទួលយកតែឯកសារ .xlsx ឬ .xls ប៉ុណ្ណោះ"
        ],
        dropFileHere: "ទម្លាក់ឯកសារ Excel របស់អ្នកនៅទីនេះ",
        supports: "គាំទ្រ .xlsx និង .xls — អតិបរមា 10 MB",
        chooseFileUpload: "ជ្រើសរើសឯកសារ និងបញ្ចូល",
        parsing: "កំពុងវិភាគឯកសារ...",
        invalidFileType: "ប្រភេទឯកសារមិនត្រឹមត្រូវ។ សូមបញ្ចូលឯកសារ Excel ។",
        noData: "រកមិនឃើញទិន្នន័យក្នុង Excel ទេ",
        failedToRead: "ការអានឯកសារ Excel បរាជ័យ",
        unableToRead: "មិនអាចអានឯកសារបានទេ។",
        reviewTitle: "ពិនិត្យមើលទិន្នន័យអ្នកផ្គត់ផ្គង់",
        reviewSubtitle: "ការត្រួតពិនិត្យចុងក្រោយមុនពេលបញ្ចូលទៅក្នុងអាជីវកម្មរបស់អ្នក។",
        changeFile: "ប្តូរឯកសារ",
        rowsFound: "ជួរដេកត្រូវបានរកឃើញក្នុងឯកសារ",
        cancel: "បោះបង់",
        finalizeImport: "បញ្ចប់ និងបញ្ចូល",
        importing: "កំពុងបញ្ចូល...",
        success: "ជោគជ័យ",
        allSupplierUploadedSuccess: "អ្នកផ្គត់ផ្គង់ទាំងអស់ត្រូវបានបញ្ចូលដោយជោគជ័យ",
        failed: "បរាជ័យ",
        bulkUploadFailed: "ការបញ្ចូលទិន្នន័យច្រើនបានបរាជ័យ",
        error: "កំហុស",
        headers: {
            supplierName: "ឈ្មោះអ្នកផ្គត់ផ្គង់",
            phoneNumber: "ទំនាក់ទំនង",
            bankName: "ឈ្មោះធនាគារ",
            accountHolderName: "ឈ្មោះម្ចាស់គណនី",
            accountNumber: "លេខគណនី",
            note: "កំណត់ចំណាំ"
        }
    },
    ReplaceReturnLocal: {
        ReplacedWith: "ប្តូរជាមួយ",
        Noreplacementhistoryfound: "រកមិនឃើញប្រវត្តិនៃការប្តូរទេ",
        Noreturnhistoryfound: "រកមិនឃើញប្រវត្តិនៃការបង្វិលសងវិញទេ",
        Productbeingreturned: "ផលិតផលដែលកំពុងត្រូវបានបង្វិលសង",
        Required: "តម្រូវឱ្យមាន",
        Selectreturnedproduct: "ជ្រើសរើសផលិតផលដែលបានបង្វិលសង",
        Searchnamescanbarcode: "ស្វែងរកតាមឈ្មោះ SKU ឬស្កេនបារកូដ",
        Browse: "ស្វែងរក",
        Stockhandling: "ការគ្រប់គ្រងការបញ្ចូលស្តុក",
        Stockinreturnedproduct: "បញ្ចូលស្តុកផលិតផលដែលបង្វិលសងវិញ",
        Ontoinventory: "បើក — ទំនិញដែលបង្វិលសងវិញនឹងត្រូវបានបន្ថែមទៅក្នុងបញ្ជីសារពើភ័ណ្ឌវិញ",
        Offreturnedonly: "បិទ — ទំនិញនឹងត្រូវបានកត់ត្រាត្រឹមតែជាការបង្វិលសងវិញប៉ុណ្ណោះ",
        Usedrestock: "ប្រើសម្រាប់គណនាការកែសម្រួលប្រាក់ចំណេញនៅពេលបញ្ចូលស្តុកឡើងវិញ",
        Willaddedbackconfirmation: "នឹងត្រូវបានបន្ថែមទៅក្នុងបញ្ជីសារពើភ័ណ្ឌវិញនៅពេលបញ្ជាក់",
        Returnreason: "មូលហេតុនៃការបង្វិលសង",
        Optional: "ជម្រើស",
        SelectReason: "ជ្រើសរើសមូលហេតុ",
        Additionalnotes: "កំណត់ចំណាំបន្ថែម",
        Describeofcustomerexplanation: "ពិពណ៌នាអំពីស្ថានភាពរបស់ទំនិញដែលបង្វិលសង ការខូចខាតដែលអាចមើលឃើញ ការពន្យល់របស់អតិថិជន...",
        Requiredmustfilledcontinue: "វាលដែលតម្រូវឱ្យមានត្រូវតែបំពេញដើម្បីបន្ត",
        Reviewdetailsbeforeconfirming: "ពិនិត្យមើលព័ត៌មានលម្អិតមុនពេលបញ្ជាក់",
        Replacementproductwilldeductedinventoryconfirmation: "ផលិតផលប្តូរនឹងត្រូវបានដកចេញពីបញ្ជីសារពើភ័ណ្ឌរបស់អ្នកនៅពេលបញ្ជាក់។",
        Choosereplacementproduct: "ជ្រើសរើសផលិតផលប្តូរ",
        Willdeductedfrominventoryconfirm: "នឹងត្រូវបានដកចេញពីបញ្ជីសារពើភ័ណ្ឌនៅពេលបញ្ជាក់",
        Thesewillattachedothereturnrecord: "រូបភាពទាំងនេះនឹងត្រូវបានភ្ជាប់ទៅនឹងកំណត់ត្រានៃការបង្វិលសង",
        Replacementitem: "ទំនិញប្តូរ",
        Addanotherproduct: "បន្ថែមផលិតផលផ្សេងទៀត",
        Replacementproductwillbe: "ផលិតផលប្តូរនឹងត្រូវ",
        deducted: "ដកចេញ",
        fromyourinventoryconfirmation: "ពីបញ្ជីសារពើភ័ណ្ឌរបស់អ្នកនៅពេលបញ្ជាក់។",
        productadjustedusingprice: "ផលិតផលដែលបង្វិលសងវិញនឹងត្រូវបានបញ្ចូលស្តុកឡើងវិញ ហើយប្រាក់ចំណេញនឹងត្រូវបានកែសម្រួលដោយប្រើតម្លៃលក់ដើម។",
        Willloggedreturnedonlynotrestocked: "នឹងត្រូវបានកត់ត្រាត្រឹមតែជាការបង្វិលសងវិញប៉ុណ្ោះ — មិនមានការបញ្ចូលស្តុកឡើងវិញទេ",
        Returnonly: "ការបង្វិលសងតែប៉ុណ្ណោះ",
        Imagesofreturnedproduct: "រូបភាពនៃផលិតផលដែលបានបង្វិលសង",
        Returnedproductwill: "ផលិតផលដែលបង្វិលសងវិញ",
        not: "មិន",
        berestockedloggedreturnedonly: "នឹងត្រូវបានបញ្ចូលស្តុកឡើងវិញទេ — កត់ត្រាត្រឹមតែជាការបង្វិលសងវិញប៉ុណ្ោះ។",
        AddImage: "បន្ថែមរូបភាព",
        STOCKIN: "បញ្ចូលស្តុក",
        LOGONLY: "ត្រឹមតែកត់ត្រា",
        ContinuetoReview: "បន្តទៅការពិនិត្យ →",
        Confirmreplacement: "បញ្ជាក់ការប្តូរ",
        Confirmreturn: "បញ្ជាក់ការបង្វិលសង",
        Filldetailsbelowproceed: "បំពេញព័ត៌មានលម្អិតខាងក្រោមដើម្បីបន្ត",
        Review: "ពិនិត្យមើលឡើងវិញ",
        editdetails: "កែសម្រួលព័ត៌មានលម្អិត",
        Configurereturndetails: "កំណត់រចនាសម្ព័ន្ធព័ត៌មានលម្អិតនៃការបង្វិលសង",
        Configurereplacementdetails: "កំណត់រចនាសម្ព័ន្ធព័ត៌មានលម្អិតនៃការប្តូរ",
        SelectSource: "ជ្រើសរើសប្រភព",
        Returning: "កំពុងបង្វិលសង",
        Replacement: "ការប្តូរ",
        WalkCustomer: "អតិថិជនទូទៅ",
        RETURNEDPRODUCT: "ផលិតផលដែលបង្វិលសង",
        REPLACEMENTPRODUCT: "ផលិតផលប្តូរ",
        STOCKOUT: "ការបញ្ចេញស្តុក",
        Netinventoryimpact: "ផលប៉ះពាល់សារពើភ័ណ្ឌសុទ្ធ",
        Replacementitemcost: "តម្លៃទំនិញប្តូរ",
        Returneditemrestockvalue: "តម្លៃបញ្ចូលស្តុកទំនិញបង្វិលសង",
        PROFITINVENTORYSUMMARY: "សេចក្តីសង្ខេបប្រាក់ចំណេញ និងសារពើភ័ណ្ឌ",
        Inventoryaction: "សកម្មភាពសារពើភ័ណ្ឌ",
        Valuededucted: "តម្លៃដែលបានដក",
        Profitadjustment: "ការកែសម្រួលប្រាក់ចំណេញ",
        stockedout: " បានបញ្ចេញស្តុក",
        restocked: " បានបញ្ចូលស្តុកវិញ",
        Noaction: "គ្មានសកម្មភាព",
        Valuebeingreturned: "តម្លៃដែលកំពុងបង្វិលសង",
        Willberestocked: "នឹងត្រូវបញ្ចូលស្តុកវិញ",
        Willbe: "នឹងត្រូវបាន",
        logged: "កត់ត្រា",
        ON: "បើក",
        OFF: "បិទ",
        Linked: "ភ្ជាប់",
        Pleaseselectreturnedproduct: "សូមជ្រើសរើសផលិតផលដែលត្រឡប់មកវិញ",
        Quantityrequired: "ត្រូវការបរិមាណ",
        Buyingpricerequired: "តម្លៃទិញត្រូវការ",
        Pleaseaddleastreplacementproduct: "សូមបន្ថែមផលិតផលជំនួសយ៉ាងតិចមួយ",
        Pleaseconfigurereturnedproductdetails: "សូមកំណត់រចនាសម្ព័ន្ធព័ត៌មានលម្អិតនៃផលិតផលដែលត្រឡប់មកវិញ",
        Pleaseselectcustomer: "សូមជ្រើសរើសអតិថិជន",
        Returndateisrequired: "ត្រូវការកាលបរិច្ឆេទត្រឡប់មកវិញ",
        Pleasefillallrequiredfields: "សូមបំពេញគ្រប់វាលដែលត្រូវការ",
        Wildeductedfrominventory: "នឹងត្រូវកាត់ពីស្តុក",
        Currentprice: "តម្លៃបច្ចុប្បន្ន",
        Defectivedamaged: "មានពិការភាព / ខូច",
        Wrongitemreceived: "ទទួលបានទំនិញខុស",
        Customerchangedmind: "អតិถិជនផ្លាស់ប្តូរចិត្ត",
        Sizefitissue: "បញ្ហាទំហំ / ភាពសមស្រប",
        Notasdescribed: "មិនត្រឹមត្រូវតាមការពិពណ៌នា",
        Other: "ផ្សេងទៀត",
        Originalsaleprice: "តម្លៃលក់ដើម (កែសម្រួលផលចំណេញ)",
        Addedbackinventory: "បានបន្ថែមទៅស្តុកវិញ",
        Notaddedinventory: "មិនបានបន្ថែមไปស្តុក",
        replacedwith: "ជំនួសដោយ",
        deductedfrominventory: "បានដកចេញពីស្តុក",
        RETURNWITHSTOCKIN: "RETURN · WITH STOCK-IN",
        RETURNNOSTOCKIN: "RETURN · NO STOCK-IN",
        MULTIPLEREPLACEMENTS: "ការជំនួសច្រើន",
        SINGLEREPLACEMENT: "ការជំនួសតែមួយ",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "RETURNED · STOCK IN",
        REPLACEMENTSTOCKOUT: "REPLACEMENT · STOCK OUT",
        Returnonlylogsthisentry: "Return only logs this entry —",
        nostockwillbeaddedorremoved: "no stock will be added or removed",
        frominventory: "from inventory.",
        Whentousethis: "When to use this:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Use Return at end of day to record items sent out for sales that came back damaged or unusable — items you want to track but cannot add back to inventory.",
        Youcanviewallpastreturnentriesin: "You can view all past return entries in",
        ReturnHistory: "Return History",
        underthe: "under the",
        Others: "Others",
        tab: "tab.",
        Negativestocktransactiondisabled: "ការប្រតិបត្តិការភាគហ៊ុនអវិជ្ជមានត្រូវបានបិទ।"
    },
    NewRLocal: {
        Originalsaleprice: "តម្លៃលក់ដើម",
        Editinghistoryonlyinventorystaysunchanged: "កំពុងកែសម្រួលតែប្រវត្តិ — សារពើភ័ណ្ឌនៅដដែល។",
        Changeshereupdatethisdetailsquantitiesaffected: "ការផ្លាស់ប្តូរនៅទីនេះធ្វើបច្ចុប្បន្នភាពតែព័ត៌មានលម្អិតនៃកំណត់ត្រានេះ (មូលហេតុ កាលបរិច្ឆេទ កំណត់ចំណាំ) ប៉ុណ្ណោះ។ បរិមាណស្តុកជាក់ស្តែង ទីតាំងប៊ីន និងទិន្នន័យផលិតផលរបស់អ្នកមិនត្រូវបានប៉ះពាល់ទេ។",
        Needtofixinventorylevelsinstead: "ត្រូវការជួសជុលកម្រិតសារពើភ័ណ្ឌជំនួសវិញ?",
        AdjustStock: "លៃតម្រូវស្តុក",
        Refund: "សងប្រាក់វិញ",
        ImportantNote: "កំណត់ចំណាំសំខាន់",
        Pleasereviewbeforecontinuing: "សូមពិនិត្យមើលមុនពេលបន្ត",
        Onceshippedreceivedanyupdatesmadeorder: "នៅពេលដែលការបញ្ជាទិញត្រូវបានដឹកជញ្ជូន ឬទទួលបាន ការធ្វើបច្ចុប្បន្នភាពណាមួយដែលបានធ្វើចំពោះការបញ្ជាទិញនឹងមិនឆ្លុះបញ្ចាំងនៅក្នុងប្រវត្តិប្រតិបត្តិការឡើយ។",
        Thisundone: "វានឹងលុបការបញ្ជាទិញជាអចិន្ត្រៃយ៍។ សកម្មភាពនេះមិនអាចមិនធ្វើវិញបានទេ។",
        Inventorywilladjustedautomatically: "សារពើភ័ណ្ឌនឹងមិនត្រូវបានលៃតម្រូវដោយស្វ័យប្រវត្តិទេ",
        Deletingthisreversevedshippedyouwillneed: "ការលុបនេះមិនត្រឡប់ការផ្លាស់ប្តូរស្តុកណាមួយឡើយ។ ប្រសិនបើទំនិញត្រូវបានទទួល/ដឹកជញ្ជូនរួចហើយ អ្នកនឹងត្រូវការ",
        reflectthecorrectstocklevels: "ដើម្បីឆ្លុះបញ្ចាំងពីកម្រិតស្តុកដែលត្រឹមត្រូវ។",
        manuallyadjustyourinventory: "លៃតម្រូវសារពើភ័ណ្ឌរបស់អ្នកដោយដៃ",
        Addremovestockforitemsthatwereshipped: "បន្ថែម/លុបស្តុកសម្រាប់ទំនិញដែលត្រូវបានដឹកជញ្ជូន",
        Addremovestockforitemsthatwerereceived: "បន្ថែម/លុបស្តុកសម្រាប់ទំនិញដែលត្រូវបានទទួល",
        Updatecostrecordspaymentwaalreadymade: "ធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាចំណាយ ប្រសិនបើការទូទាត់ត្រូវបានធ្វើរួចហើយ",
        Reconcilerecordsandoutstandingpayments: "សម្រុះសម្រួលកំណត់ត្រា និងការទូទាត់ដែលនៅសេសសល់"
    },
    ReceivablesLocal: {
        Receivables: "ថវិកាត្រូវទទួល",
        Manageandtrackcustomerduebalances: "គ្រប់គ្រងនិងតាមដានសមតុល្យអតិថិជនដែលត្រូវបង់",
        Viewcustomerduebalancereport: "មើលរបាយការណ៍សមតុល្យអតិថិជនដែលត្រូវបង់",
        Viewsupplierduebalancereport: "មើលរបាយការណ៍សមតុល្យអ្នកផ្គត់ផ្គង់ដែលត្រូវបង់",
        DueBalance: "សមតុល្យត្រូវបង់",
        Unpaid: "មិនទាន់បង់",
        PartiallyPaid: "បង់ផ្នែកខ្លះ",
        Paid: "បានបង់",
        HighestBalance: "សមតុល្យខ្ពស់បំផុត",
        LowestBalance: "សមតុល្យទាបបំផុត",
        Filldetailsrecordpayment: "បំពេញព័ត៌មានលម្អិតដើម្បីកត់ត្រាការទូទាត់",
        NewPaymentEntry: "ការទូទាត់ថ្មី",
        EditPaymentEntry: "កែសម្រួលការទូទាត់",
        Nosuppliersfound: "រកមិនឃើញអ្នកផ្គត់ផ្គង់",
        Nocustomersfound: "រកមិនឃើញអតិថិជន",
        LowtoHigh: "ពីទាបទៅខ្ពស់",
        HightoLow: "ពីខ្ពស់ទៅទាប",
        AttachmentUploadedSc: "ឯកសារភ្ជាប់បានផ្ទុកឡើងដោយជោគជ័យ",
        AttachmentUploadedF: "ឯកសារភ្ជាប់ផ្ទុកឡើងបរាជ័យ",
        Pay: "បង់",
        NoBillsFound: "រកមិនឃើញវិក្កយបត្រ",
        Thiscustomerhasunpaidbills: "អតិថិជននេះមិនមានវិក្កយបត្រមិនទាន់បង់ទេ។",
        TotalDue: "សរុបត្រូវបង់",
        BillsFound: "រកឃើញវិក្កយបត្រ",
        DeselectAll: "ឈប់ជ្រើសរើសទាំងអស់",
        SelectAll: "ជ្រើសរើសទាំងអស់",
        ShowDetails: "បង្ហាញព័ត៌មានលម្អិត"
    },
    AssetsNewLocal: {
        Assignedon: "បានប្រគល់ជូននៅថ្ងៃ",
        Total: "សរុប",
        Assigned: "បានប្រគល់ជូន",
        Remaining: "នៅសល់",
        Available: "អាចប្រើបាន",
        NoSerialNumbers: "គ្មានលេខសម្គាល់",
        UpdateExistingAssetDetails: "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានលម្អិតទ្រព្យសកម្មដែលមានស្រាប់",
        RegisterNewBusinessAsset: "ចុះឈ្មោះទ្រព្យសកម្មអាជីវកម្មថ្មី",
        BasicInformation: "ព័ត៌មានមូលដ្ឋាន",
        AssetDetails: "ព័ត៌មានលម្អិតទ្រព្យសកម្ម",
        Quantity: "បរិមាណ",
        SerialNumbers: "លេខសម្គាល់",
        SerialNumberPlaceholder: "លេខសម្គាល់",
        AddSerialNumber: "បន្ថែមលេខសម្គាល់",
        SerialNumbersOptional: "លេខសម្គាល់មិនបង្ខំទេ។ អ្នកអាចបន្ថែមរហូតដល់",
        AssetImages: "រូបភាពទ្រព្យសកម្ម",
        AdditionalNotes: "កំណត់សម្គាល់បន្ថែម",
        AdditionalNotesPlaceholder: "ព័ត៌មានលម្អិតបន្ថែម ឬប្រវត្តិនៃការថែទាំ...",
        Updating: "កំពុងធ្វើបច្ចុប្បន្នភាព...",
        Adding: "កំពុងបន្ថែម...",
        ITEquipmentPlaceholder: "ឧ. ឧបករណ៍ព័ត៌មានវិទ្យา",
        LoadingMoreActivities: "កំពុងផ្ទុកសកម្មភាពបន្ថែម...",
        AssignedAssets: "សម្បត្តិដែលបានចាត់តាំង",
        Noassetsassignedstaffmember: "មិនមានសម្បត្តិដែលបានចាត់តាំងឱ្យបុគ្គលិកនេះទេ។",
        Assignassetstaff: "ចាត់តាំងសម្បត្តិឱ្យបុគ្គលិក",
        Returnassetfromstaff: "ត្រឡប់សម្បត្តិនេះពីបុគ្គលិក",
        AssignmentDetails: "ព័ត៌មានលម្អិតនៃការចាត់តាំង",
        Serial: "លេខស៊េរី",
        ViewAssets: "មើលសម្បត្តិទាំងអស់",
        ViewByStaff: "មើលតាមបុគ្គលិក",
        AssignedHistory: "ប្រវត្តិនៃការចាត់តាំង",
        Returned: "បានត្រឡប់",
        Returnedon: "បានត្រឡប់នៅថ្ងៃ",
        ReturnedBy: "ត្រឡប់ដោយ",
        AssignedTo: "បានចាត់តាំងទៅ",
        NoHistoryRecords: "គ្មានកំណត់ត្រាប្រវត្តិ",
        Selectstaffmemberviewtheirassets: "ជ្រើសរើសបុគ្គលិកដើម្បីមើលសម្បត្តិរបស់ពួកគេ",
        Deleted: "បានលុប",
        searchPlaceholder: "ស្វែងរកទ្រព្យសម្បត្តិតាមឈ្មោះ ឬលេខស៊េរី..."
    },
    InventoryCountLocale: {
        InventoryCount: "ការរាប់ស្តុក",
        Viewinventorycountreport: "មើលរបាយការណ៍រាប់ស្តុក",
        ItemsCount: "ចំនួនទំនិញ",
        All: "ទាំងអស់",
        InProgress: "កំពុងដំណើរការ",
        Submitted: "បានដាក់ស្នើ",
        awaitingreview: "កំពុងរង់ចាំការពិនិត្យ",
        EditInventoryCount: "កែសម្រួលការរាប់ស្តុក",
        NewInventoryCount: "ការរាប់ស្តុកថ្មី",
        Modifyinventorycountsheetdetails: "កែប្រែព័ត៌មានលម្អិតនៃសន្លឹករាប់ស្តុក",
        Startanewinventorycountsheet: "ចាប់ផ្តើមសន្លឹករាប់ស្តុកថ្មី",
        GeneralInformation: "ព័ត៌មានទូទៅ",
        Title: "ចំណងជើង",
        SaveChanges: "រក្សាទុកការផ្លាស់ប្តូរ",
        Selectproductsforthisinventorycountsheet: "ជ្រើសរើសផលិតផលសម្រាប់សន្លឹកនេះ",
        InventoryCountDetails: "ព័ត៌មានលម្អិតនៃការរាប់ស្តុក",
        Inventorycountsheetdetails: "ព័ត៌មានលម្អិតនៃសន្លឹករាប់ស្តុក",
        Viewingdetailsforcountsheet: "កំពុងមើលព័ត៌មានលម្អិតនៃសន្លឹករាប់",
        Started: "បានចាប់ផ្តើម",
        TaskSheets: "សន្លឹកកិច្ចការ",
        Allitems: "ទំនិញទាំងអស់",
        NotStarted: "មិនទាន់ចាប់ផ្តើម",
        Completed: "បានបញ្ចប់",
        Results: "លទ្ធផល",
        ViewResults: "មើលលទ្ធផល",
        DeleteInventoryCount: "លុបការរាប់ស្តុក",
        Viewingtransactionandadjustments: "កំពុងមើលកំណត់ត្រាប្រតិបត្តិការនិងការកែតម្រូវស្តុក",
        Productsadjusted: "ផលិតផលដែលបានកែតម្រូវ",
        Assignee: "អ្នកទទួលខុសត្រូវ",
        Tasksheetdetails: "ព័ត៌មានលម្អិតនៃសន្លឹកកិច្ចការ",
        Draft: "ពង្រាង",
        VariantQuantities: "បរិមាណវ៉ារ្យ៉ង់",
        AssignedProducts: "ផលិតផលដែលបានចាត់តាំង",
        ReturnAsset: "ត្រឡប់សម្បត្តិ",
        EditTasksheet: "កែសម្រួលសន្លឹកកិច្ចការ",
        NewTasksheet: "សន្លឹកកិច្ចការថ្មី",
        Updatetasksheetdetails: "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានលម្អិតនៃសន្លឹកកិច្ចការ",
        Starttasksheetforthisinventorycount: "ចាប់ផ្តើមសន្លឹកកិច្ចការថ្មីសម្រាប់ការរាប់ស្តុកនេះ",
        TaskSheetInformation: "ព័ត៌មានសន្លឹកកិច្ចការ",
        SheetTitle: "ចំណងជើងសន្លឹក",
        Entersheettitle: "បញ្ចូលចំណងជើងសន្លឹក",
        SubmissionResult: "លទ្ធផលនៃការដាក់ស្នើ",
        ReviewChanges: "ពិនិត្យការផ្លាស់ប្តូរ",
        Viewingsubmissionresultsforthisinventorycount: "កំពុងមើលលទ្ធផលនៃការដាក់ស្នើសម្រាប់ការរាប់ស្តុកនេះ",
        Reviewyourinventorycountbeforesubmitting: "ពិនិត្យការរាប់ស្តុករបស់អ្នកមុនពេលដាក់ស្នើ"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "ផ្ទុកការរាប់មិនបានសម្រេច",
        NoInventoryCounts: "គ្មានការរាប់ស្តុក",
        NoMatches: "គ្មានលទ្ធផល",
        Therearenoinventorycountswiththestatus: "គ្មានការរាប់ស្តុកដែលមានស្ថានភាព",
        Noinventorycountsfoundyoursearchterm: "រកមិនឃើញការរាប់ស្តុកដែលត្រូវនឹងពាក្យស្វែងរករបស់អ្នកទេ។",
        Thereareinventorycountsrecordedyetforthisbusiness: "មិនទាន់មានការរាប់ស្តុកណាមួយត្រូវបានកត់ត្រាសម្រាប់អាជីវកម្មនេះទេ។"
    },
    StockinModalP: {
        StockInNow: "បញ្ចូលស្តុកឥឡូវនេះ",
        Settheopeningquantityforthisproductrightnow: "កំណត់បរិមាណដំបូងសម្រាប់ផលិតផលនេះឥឡូវនេះ。",
        Addinitialstock: "បន្ថែមស្តុកដំបូង?",
        dothislater: "ខ្ញុំនឹងធ្វើវានៅពេលក្រោយ",
        Productadded: "បានបន្ថែមផលិតផល!",
        isready: "ត្រៀមខ្លួនហើយ។",
        SeeHowItWorks: "មើលវិធីដំណើរការ",
        NoSalesOrdersFound: "រកមិនឃើញការបញ្ជាទិញលក់ទេ",
        NoPurchaseOrdersFound: "រកមិនឃើញការបញ្ជាទិញទិញទេ",
        Startcreatingoutgoinginventoryrevenue: "ចាប់ផ្តើមបង្កើតការបញ្ជាទិញលក់ដើម្បីតាមដានស្តុកចេញ និងចំណូលរបស់អ្នក។",
        Trackrestockssupplierplace: "តាមដានការបញ្ចូលស្តុក និងការបញ្ជាទិញពីអ្នកផ្គត់ផ្គង់នៅកន្លែងតែមួយ។",
        CreateSalesOrder: "បង្កើតការបញ្ជាទិញលក់",
        CreatePurchaseOrder: "បង្កើតការបញ្ជាទិញ",
    },
    PriceReference: {
        LastPurchasePrice: "តម្លៃទិញចុងក្រោយ"
    },
    dialy_report: "របាយការណ៍ចលនាប្រចាំថ្ងៃ",
    Quotation: "សម្រង់តម្លៃ",
    Quote: "សម្រង់តម្លៃ",
    Assignee: "អ្នកទទួលខុសត្រូវ",
    dayStart: "ការចាប់ផ្តើមថ្ងៃ",

    ShowTotalAmount: "ចំនួនសរុប",


    tutorial: {
        watchTitle: 'មើលការបង្រៀនជាជំហានៗ',
        watchDesc: 'រៀន SimplyStock នៅលើឆានែល YouTube របស់យើង',
        modalTitle: 'នៅតែបន្តជាមួយ SimplyStock',
        modalDesc: 'ជាវដើម្បីទទួលបានការបង្រៀនថ្មីនៅពេលដែលពួកគេទម្លាក់',
        feature1Title: 'លក្ខណៈពិសេសថ្មី walkthroughs',
        feature1Sub: 'ការបង្កើនថ្មីទាំងអស់ត្រូវបានពន្យល់ដោយវីដេអូខ្លី - ដូច្នេះអ្នកមិនដែលបាត់បង់អ្វីដែលថ្មី',
        feature2Title: 'វីដេអូខ្លីៗអំពីរបៀបធ្វើ',
        feature2Sub: 'រៀបចំស្តុក វិក្កយបត្រ ការចូលប្រើបុគ្គលិក និងច្រើនទៀតក្នុងរយៈពេលតិចជាង 5 នាទី',
        feature3Title: 'ការជូនដំណឹងភ្លាមៗ',
        feature3Sub: 'ទទួលបានការជូនដំណឹងនៅពេលដែលការបង្រៀនថ្មីត្រូវបានផ្សាយផ្ទាល់ - រៀនតាមល្បឿនផ្ទាល់ខ្លួនរបស់អ្នក',
        feature4Title: '100% ឥតគិតថ្លៃជានិច្ច',
        feature4Sub: 'ការបង្រៀនទាំងអស់គឺឥតគិតថ្លៃជារៀងរហូត — មិនចាំបាច់ឡុកចូល ឬជាវទេ',
        subscribeBtn: 'ជាវ ទៅ SimplyStock',
        maybeLater: 'ប្រហែលជាក្រោយៗ'
    }
    ,
    dailyCashReport: {
        "title": "របាយការណ៍សាច់ប្រាក់ប្រចាំថ្ងៃ",
        "subtitle": "អ្នកណាបានបង់អ្វី ថ្ងៃណា និងអ្វីដែលនៅជំពាក់ — ដាក់ជាក្រុមពីព័ត៌មានលម្អិតលក់។",
        "totalSales": "ការលក់សរុប",
        "cashReceived": "សរុបទទួលបាន",
        "outstanding": "នៅជំពាក់",
        "collectionRate": "អត្រាប្រមូល",
        "grandTotalAllDates": "សរុបរួម (កាលបរិច្ឆេទទាំងអស់)",
        "totalLabel": "សរុប",
        "loading": "កំពុងផ្ទុក...",
        "noData": "រកមិនឃើញទិន្នន័យសម្រាប់ចន្លោះកាលបរិច្ឆេទដែលបានជ្រើសរើសទេ។",
        "loadingMore": "កំពុងផ្ទុកបន្ថែម..."
    },
    dailyCashReportColumns: {
        "date": "កាលបរិច្ឆេទ",
        "customer": "អតិថិជន",
        "productsSold": "ផលិតផលដែលបានលក់",
        "products": "ផលិតផល",
        "salesAmount": "ចំនួនលក់",
        "sales": "លក់",
        "received": "សរុបទទួលបាន",
        "receivedShort": "បានទទួល",
        "debited": "បានកត់ចូលបញ្ជី",
        "due": "ត្រូវបង់",
        "paymentModes": "វិធីទូទាត់",
        "mode": "របៀប"
    },
    ProductFormNew: {
        BasicInfo: "ព័ត៌មានមូលដ្ឋាន",
        ProductImage: "រូបភាពផលិតផល",
        Images: "រូបភាព",
        Pricing: "ការកំណត់តម្លៃ",
        Everypriceneedsbothalabelandanamount: "រាល់តម្លៃត្រូវការស្លាក និងចំនួន",
        AddalabellikeWholesaleorRetailtoidentifythisprice: "បន្ថែមស្លាកដូចជា \"លក់ដុំ\" ឬ \"លក់រាយ\"",
        Entertheamountforthisprice: "បញ្ចូលចំនួនសម្រាប់តម្លៃនេះ",
        AddMultiplePrice: "បន្ថែមតម្លៃច្រើន",
        NoPhotosLetAiFind: "គ្មានរូបថតទេ? ឱ្យ AI ស្វែងរករូបភាពផលិតផល",
        AddProductImagesTitle: "បន្ថែមរូបភាពផលិតផល",
        ChooseHowToAddPhotos: "ជ្រើសរើសរបៀបបន្ថែមរូបថតសម្រាប់ផលិតផលនេះ៖",
        SearchWithAi: "ស្វែងរកជាមួយ AI",
        SearchWithAiDesc: "ស្វែងរក និងជ្រើសរើសរូបភាពផលិតផលដោយស្វ័យប្រវត្តិតាមរយៈ AI",
        FilesFileExplorer: "ឯកសារ (File Explorer)",
        FilesFileExplorerDesc: "ជ្រើសរើសរូបភាពផ្ទាល់ពីកុំព្យូទ័ររបស់អ្នក",
        AiProductImageFinder: "កម្មវិធីស្វែងរករូបភាពផលិតផល AI",
        AiProductImageFinderDesc: "ស្វែងរក និងជ្រើសរើសរូបភាពសម្រាប់ផលិតផលរបស់អ្នក",
        TypeProductNamePlaceholder: "វាយឈ្មោះផលិតផល...",
        SearchForYourProduct: "ស្វែងរកផលិតផលរបស់អ្នក",
        SearchForYourProductHint: `សាកល្បងឈ្មោះម៉ាក ឬផលិតផល`,
        ImagesSelected: "រូបភាពត្រូវបានជ្រើសរើស",
        AddSelected: "បន្ថែមអ្វីដែលបានជ្រើសរើស"
    },
    NewVariantModal: {
        Qty: "បរិមាណ"
    }
}

export default km
